import { push }                                                                                                                                                                                                                      from "connected-react-router";
import rename                                                                                                                                                                                                                        from "deep-rename-keys";
import { clearSection, dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType, dmpRemoteCommandFailureContextualizedType, dmpRemoteCommandSuccessContextualizedType, setGlobalConfiguration, setMssConfiguration } from "dmpconnectjsapp-base/actions";
import { formatDeleteDocumentParams, formatFindDocumentsByUniqueId, formatGetDocumentContentByUniqueIdParams, formatGetDocumentHistoryByUniqueId, formatGetMssHpInfosParams, formatUpdateUserDmpAccessAuthorizationParams }          from "dmpconnectjsapp-base/actions/config/commandParamsFormatters";
import commands, { mssSubTypes }                                                                                                                                                                                                     from "dmpconnectjsapp-base/actions/config/commands";
import { apiSections, mssLoginTypes }                                                                                                                                                                                                from "dmpconnectjsapp-base/constants";
import { remoteErrors, softwareErrors }                                                                                                                                                                                              from "dmpconnectjsapp-base/errors";
import { getApiType, getConfigurationValue, getDmpParameterFromState, getHealthcareSetting, getInteropCodesFromState, getMssAccountConfigByEmail, getMssApiType, getMssEmail, getNosCodesFromState, getPracticeSetting }             from "dmpconnectjsapp-base/helpers/accessors";
import { isReady }                                                                                                                                                                                                                   from "dmpconnectjsapp-base/helpers/common";
import { documentStatuses, documentVisibilityStatuses, explodeUniqueUUid, getCdaHeaders, getDocumentData, getUniqueUUid, isHiddenFor }                                                                                               from "dmpconnectjsapp-base/helpers/findDocuments";
import { authenticationTypes, canUpload, getAccessRightsProps, isTransactionAllowed, transactions }                                                                                                                                  from "dmpconnectjsapp-base/rules/accessRights";
import { websocketChannel }                                                                                                                                                                                                          from "dmpconnectjsapp-base/sagas/connectorSagas";
import { hasCustomStyleSheetApplied }                                                                                                                                                                                                from "dmpconnectjsapp-base/utils/clinicalDocument";
import { b64DecodeUnicode }                                                                                                                                                                                                          from "dmpconnectjsapp-base/utils/dataUtils";
import { encodeIns }                                                                                                                                                                                                                 from "dmpconnectjsapp-base/utils/insUtils";
import { extractPracticeLocationFromState }                                                                                                                                                                                          from "dmpconnectjsapp-base/utils/practiceLocation";
import FileType                                                                                                                                                                                                                      from "file-type/core";
import jwt                                                                                                                                                                                                                           from "jsonwebtoken";
import JwksClient                                                                                                                                                                                                                    from "jwks-rsa";
import moment                                                                                                                                                                                                                        from "moment";
import * as React                                                                                                                                                                                                                    from "react";

import { toast }                                                                                                                                                                                                                                          from "react-toastify";
import { actionChannel, all, call, put, race, select, take }                                                                                                                                                                                              from "redux-saga/effects";
import { js2xml, xml2js }                                                                                                                                                                                                                                 from "xml-js";
import { ValidationError }                                                                                                                                                                                                                                from "yup";
import env                                                                                                                                                                                                                                                from "../../envVariables";
import { findDocuments, getAction, logout, removeDocFromPersistantData, removeDocumentFromCache, resetMssEmailContent, selectINS, setModalError, setMssEmailContent, setMssPatientInfos, setPinCode, setShowMssPopup, setUserJWT, toggleLoadingBackdrop } from "../actions";

import { clearRemoteSection, remoteDeleteDocument, remoteExportEmailDone, remoteFindPatients, remoteGetCertifiedIdentity, remoteSendDocument, remoteSetExportUniqueIds, remoteSubmitDoc, remoteValidateCDADocuments, saveAATData, sendRemoteOutMessage, sendRemoteResponse, stopRemoteControl } from "../actions/dmpconnectRemoteActions";
import { accessModes, API_TYPES, dmpconnectConfigurationActionConstants, dmpconnectRemoteActionConstants, dmpStatuses, documentFormatNames, documentFormats, documentFormatsCda, documentFormatTypeMimes, userAuthorizationAction, userAuthorizationStatuses }                                  from "../constants";
import { insTypes }                                                                                                                                                                                                                                                                             from "../constants/dmpConstants";

import { createErrorDetails, createModalError } from "../errors";
import { errorActions }                         from "../errors/errorActions";
import { errorTypes }                           from "../errors/errorConfiguration";

import { getCurrentPathname, getDmpLandingPage, getDocumentRedirectUrl, getEsUser, getSessionId, isMssActive, isUserLoggedIn as isUserLoggedInAccessor }          from "../helpers";
import { getDirectAuthenticationStatus as getDirectAuthenticationStatusAccessor }                                                                                 from "../helpers/directAuthenticationDMPStatus";
import { getDocumentFromUniqueId }                                                                                                                                from "../helpers/documentUtils";
import { getCdaContent }                                                                                                                                          from "../helpers/findDocuments";
import { generateMessageId, getSendMssEmailAction, mssFolderTypes }                                                                                               from "../helpers/mss";
import { backPagesTypes, getBackPage }                                                                                                                            from "../helpers/nav";
import { convertJsResultToXmlReadyObject, generateRemoteFailureResponse, getInsFromPatient, remoteActions, remoteFormats, remoteResponseChannels, remoteSources } from "../helpers/remote";
import { extractDeleteDocumentParams, extractJSONDeleteDocumentParams }                                                                                           from "../helpers/remote/deleteDocument";
import { extractFindDmpParams, extractJSONFindDmpParams, generateFindDmpResponse }                                                                                from "../helpers/remote/findDmp";
import { extractFindDocumentsJSONParams, extractFindDocumentsParams }                                                                                             from "../helpers/remote/findDocuments";
import { extractGetCertifiedIdentityParams, extractJSONGetCertifiedIdentityParams, generateGetCertifiedIdentityResponse }                                         from "../helpers/remote/getCertifiedIdentidy";
import { generateGetCurrentDmpBody, generateGetCurrentDmpResponse }                                                                                               from "../helpers/remote/getCurrentDmp";
import { extractGetDocumentsStatusParams, extractJSONGetDocumentsStatusParams }                                                                                   from "../helpers/remote/getDocumentsStatus";
import { generateGetEfficienceVersionResponse }                                                                                                                   from "../helpers/remote/getEfficienceVersion";
import { extractGetMssInfosParams, extractJSONGetMssInfosParams, formatQuery }                                                                                    from "../helpers/remote/getMssHpInfos";
import { extractGetMssNbUnreadMessagesParams, extractJSONGetMssNbUnreadMessagesParams }                                                                           from "../helpers/remote/getMssNbUnreadMessages";
import { extractJSONOpenDmp, extractOpenDmp }                                                                                                                     from "../helpers/remote/openDmp";
import { extractJSONOpenDocumentParams, extractOpenDocumentParams }                                                                                               from "../helpers/remote/openDocument";
import { extractJSONSendMssMessageParams, extractSendMssMessageParams }                                                                                           from "../helpers/remote/sendMssMessage";
import { extractJSONSendSubmissionSetParams, extractJSONSubmitDocumentParams, extractSubmitDocumentParams }                                                       from "../helpers/remote/submitDocument";
import { generateTestDmpExistenceResponse }                                                                                                                       from "../helpers/remote/testDmpExistence";
import { validateCommand }                                                                                                                                        from "../helpers/remote/validateCommands";
import { formatUploadDocumentParams, getFormatAndContent }                                                                                                        from "../helpers/sendDocument";
import { calculateVisibility, canConsultDocument }                                                                                                                from "../rules/documentRules";
import { b64EncodeUnicode, base64ToArrayBuffer, checkFormatAndBase64Match, generateUniqueId, imapUtf7Encode }                                                     from "../utils/dataUtils";
import { postMessageToIframeParent }                                                                                                                              from "../utils/iframe";
import { sendActionAndWaitResult }                                                                                                                                from "./actionsSagas";
import { handleDownloadAllAttachments }                                                                                                                           from "./mssSagas";
import { handleSetConfidentialityLevel, handleSetDmpAccessMode }                                                                                                  from "./patientSagas";
import { getDocumentInfoFromCache }                                                                                                                               from "./utilsSagas";

const getAccessRights     = state => getAccessRightsProps(state);
const getSelectedINS      = ({ dmpconnect: { selectedIns } }) => selectedIns;
const getSecretConnection = ({ dmpconnect: { secretConnection } }) => secretConnection;

const getDirectAuthenticationStatus = (state) => {
  const { dmpconnect: { selectedIns } } = state;
  return getDirectAuthenticationStatusAccessor(
    state,
    selectedIns
  );
};

function getDocumentOptions (state) {
  const {
          dmpConnectPersistedAppConfiguration: {
            forceSchematronsValidation = false,
            ignorePdfA1Transparency    = false,
            disabledPdfA1Conversion    = false
          }
        } = state;
  
  return {
    forceSchematronsValidation,
    ignorePdfA1Transparency,
    disabledPdfA1Conversion
  };
}

export const isDebugRemoteActive = ({ dmpconnectConnectorConfig }) => (getConfigurationValue(
  "debugActivateRemoteControl",
  dmpconnectConnectorConfig
));

export const isRemoteControlActive     = ({ dmpconnectConnectorConfig }) => (
  getConfigurationValue("debugActivateRemoteControl", dmpconnectConnectorConfig)
  && !getConfigurationValue("forceDesactivateRemoteControl", dmpconnectConnectorConfig)
);
export const getShowNotifications      = ({ dmpConnectPersistedAppConfiguration }) => (
  !dmpConnectPersistedAppConfiguration.hideRemoteControlNotifications
);
export const getRemoteDisableExports   = ({ dmpConnectPersistedAppConfiguration }) => (
  dmpConnectPersistedAppConfiguration.remoteControlDisableExports
);
export const getRemoteExportVitaleData = ({ dmpConnectPersistedAppConfiguration }) => (
  dmpConnectPersistedAppConfiguration.remoteExportVitaleData
);
export const getRemoteExportChannel    = ({ dmpConnectPersistedAppConfiguration }) => (
  dmpConnectPersistedAppConfiguration.remoteExportChannel
);
export const getRemoteExportChannelUrl = ({ dmpConnectPersistedAppConfiguration }) => (
  dmpConnectPersistedAppConfiguration.remoteExportChannelUrl
);
export const getRemoteExchangeFormat   = ({ dmpConnectPersistedAppConfiguration }) => (
  dmpConnectPersistedAppConfiguration.remoteFormat
);

function * updateToast (requestId, type, keepOnScreen = false) {
  const showNotifications = yield select(getShowNotifications);
  if (showNotifications === true) {
    // toast.dismiss(requestId);
    toast.update(
      requestId,
      {
        type,
        autoClose: keepOnScreen === true ? false : 3000
      }
    );
    if (!keepOnScreen) {
      setTimeout(() => toast.dismiss(requestId), 3000);
    }
  }
}

function sendToOtherChannel (response, channel, channelUrl, showToastOnSuccess = false, toastContent = "", type = remoteFormats.XML) {
  let xmlResponse;
  if (type === remoteFormats.JSON) {
    xmlResponse = JSON.stringify({ answer: rename(response, key => key.replace(/^@/, "")) }, null, 4);
  } else {
    const xmlReady = convertJsResultToXmlReadyObject({ answer: response });
    const xml      = js2xml(xmlReady, { compact: true, spaces: 4 });
    xmlResponse    = `<?xml version="1.0" encoding="utf-8"?>\n${xml}`;
  }
  
  if (channel.toLowerCase() === remoteResponseChannels.IFRAME.toLowerCase()) {
    postMessageToIframeParent({ type: "remoteNotification", data: b64EncodeUnicode(xmlResponse) });
    if (showToastOnSuccess) {
      const id = generateUniqueId();
      toast(
        toastContent,
        {
          toastId        : id,
          type           : "success",
          position       : "top-right",
          closeOnClick   : true,
          autoClose      : 2000,
          hideProgressBar: true
        }
      );
      setTimeout(() => toast.dismiss(id), 2000);
    }
  } else if (channel.toLowerCase() === remoteResponseChannels.URL.toLowerCase()) {
    console.log("outgoingMessage_post", xmlResponse);
    fetch(channelUrl, {
      method : "post",
      headers: {
        Accept        : "application/json, text/plain, */*",
        "Content-Type": "application/xml"
      },
      body   : xmlResponse
    }).then((res) => {
      if (!res.ok) {
        const erreur  = (
          // eslint-disable-next-line react/jsx-filename-extension
          <>
            {" HTTP "}
            {res.status}
            {" "}
            -
            {" "}
            {res.statusText}
          </>
        );
        const message = "Une erreur s'est produite pendant l'export";
        res.json().then((json) => {
          toast((
              <>
                <div>
                  {json.message || message}
                  <br />
                  {json.erreur || erreur}
                </div>
              </>
            ),
            {
              type           : "error",
              position       : "top-right",
              closeOnClick   : true,
              autoClose      : 10000,
              hideProgressBar: true,
              draggable      : false
            });
        }).catch(() => {
          toast((
              <>
                <div>
                  {message}
                  <br />
                  {erreur}
                </div>
              </>
            ),
            {
              type           : "error",
              position       : "top-right",
              closeOnClick   : true,
              autoClose      : 10000,
              hideProgressBar: true,
              draggable      : false
            });
        });
      } else if (showToastOnSuccess) {
        const id = generateUniqueId();
        toast(
          toastContent,
          {
            toastId        : id,
            type           : "success",
            position       : "top-right",
            closeOnClick   : true,
            autoClose      : 2000,
            hideProgressBar: true
          }
        );
        setTimeout(() => toast.dismiss(id), 2000);
      }
    }).catch((e) => {
      toast("Erreur de connection pendant l'export",
        {
          type           : "error",
          position       : "top-right",
          closeOnClick   : true,
          autoClose      : 10000,
          progress       : undefined,
          hideProgressBar: true,
          draggable      : false
        });
    });
  }
}

function * sendResponse (response, channel, channelUrl, type) {
  if (channel === remoteResponseChannels.CONNECTOR) {
    console.log("outgoingMessage_connector", response);
    yield put(sendRemoteResponse(response));
  } else {
    sendToOtherChannel(response, channel, channelUrl, false, "", type);
  }
}

// function* sendDelayedResponse(response, channel, channelUrl) {
//   if (channel === remoteResponseChannels.CONNECTOR) {
//     yield put(sendRemoteOutMessage(response));
//   } else {
//     sendToOtherChannel(response, channel, channelUrl);
//   }
// }

function * handleError (requestId, responseChannel, channelUrl, type, error, details) {
  const response = generateRemoteFailureResponse(requestId, error, details);
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(updateToast, requestId, toast.TYPE.ERROR);
}

function * handleLoggedInError (requestId, responseChannel, channelUrl, type) {
  const response = generateRemoteFailureResponse(requestId, {
    i_apiErrorType: errorTypes.RemoteErrors,
    i_apiErrorCode: "NO_PS_LOGGED_IN"
  });
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  
  yield call(updateToast, requestId, toast.TYPE.ERROR);
}

function * handleUnknownActionError (requestId, responseChannel, channelUrl, type) {
  const response = generateRemoteFailureResponse(requestId, {
    i_apiErrorType: errorTypes.RemoteErrors,
    i_apiErrorCode: "UNKNONW_ACTION"
  });
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(updateToast, requestId, toast.TYPE.ERROR);
}

function * handleRefusedActionError (requestId, responseChannel, channelUrl, type, customExtendedMessage = "") {
  const response = generateRemoteFailureResponse(requestId, {
    i_apiErrorType                : errorTypes.RemoteErrors,
    i_apiErrorCode                : "REFUSED_ACTION",
    s_apiErrorExtendedInformations: customExtendedMessage || "Action non autorisée"
  });
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(updateToast, requestId, toast.TYPE.ERROR);
}

function * handleDMPNotFoundError (requestId, responseChannel, channelUrl, type) {
  const response = generateRemoteFailureResponse(requestId, {
    i_apiErrorType                : errorTypes.RemoteErrors,
    i_apiErrorCode                : "DMP_NOT_FOUND",
    s_apiErrorExtendedInformations: "Aucun DMP associé à l’INS fourni."
  });
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(updateToast, requestId, toast.TYPE.ERROR);
}

function * handleInvalidInsTypeError (requestId, responseChannel, channelUrl, type) {
  const response = generateRemoteFailureResponse(requestId, {
    i_apiErrorType                : errorTypes.RemoteErrors,
    i_apiErrorCode                : "INVALID_INS_TYPE",
    s_apiErrorExtendedInformations: "Type d’INS inconnu."
  });
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(updateToast, requestId, toast.TYPE.ERROR);
}

function * handleAddAuthorization (ins, psId, airOnly, authenticationType, esId, requestId, responseChannel, channelUrl, type) {
  let actions = [];
  actions.push({
    func      : getAction(
      commands.updateUserDmpAccessAuthorization,
      apiSections.USER_DMP_ACCESS_AUTHORIZATION_SECTION,
      formatUpdateUserDmpAccessAuthorizationParams(
        ins,
        userAuthorizationAction.AddAuthorization,
        0
      ),
      {
        subSection   : `${ins}/${psId}`,
        contextParams: { ins, performer: psId, fromRemote: true }
      }
    ),
    section   : apiSections.USER_DMP_ACCESS_AUTHORIZATION_SECTION,
    subSection: `${ins}/${psId}`
  });
  
  if (
    !airOnly
    && authenticationType === authenticationTypes.AIR
  ) {
    actions.push({
      func      : getAction(
        commands.updateUserDmpAccessAuthorization,
        apiSections.USER_DMP_ACCESS_AUTHORIZATION_SECTION,
        formatUpdateUserDmpAccessAuthorizationParams(
          ins,
          userAuthorizationAction.AddAuthorization,
          0
        ),
        {
          subSection   : `${ins}/${esId}`,
          contextParams: { ins, performer: esId, fromRemote: true },
          forceEs      : true
        }
      ),
      section   : apiSections.USER_DMP_ACCESS_AUTHORIZATION_SECTION,
      subSection: `${ins}/${esId}`
    });
  }
  
  const results = yield all(actions.map(action => call(sendActionAndWaitResult, action)));
  
  if (results.some(result => !isReady(result.data))) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, results);
    return false;
  }
  
  return true;
}

function * isDmpAuthorized (ins, requestId, responseChannel, channelUrl, type, addAccessAuthorization, doNotSendError = false) {
  const { accessRights: { psId, airOnly, authenticationType, esId } = {} } = yield select(getAccessRights);
  
  const result = yield call(sendActionAndWaitResult, {
    func      : getAction(
      commands.getDirectAuthenticationDMPStatus,
      apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
      { s_ins: ins },
      {
        subSection   : `${ins}/${psId}`,
        contextParams: { ins, performer: psId },
        remote       : true
      }
    ),
    section   : apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
    subSection: `${ins}/${psId}`
  });
  
  // vérifier l'autorisation d'accès
  const {
          data: {
            ExistingTestAnswer: {
              i_dmpStatus        : dmpStatus,
              i_userAuthorization: authorization
            } = {}
          }
        } = result;
  
  if (isReady(result.data)) {
    // dmp n'existe pas
    if (dmpStatus !== dmpStatuses.DMPExist) {
      yield call(handleDMPNotFoundError, requestId, responseChannel, channelUrl, type);
      return false;
    }
    // pas autorisé
    else if (authorization !== userAuthorizationStatuses.AuthorizationExist) {
      if (addAccessAuthorization) {
        const ok = yield call(handleAddAuthorization, ins, psId, airOnly, authenticationType, esId, requestId, responseChannel, channelUrl, type);
        if (!ok) {
          yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type, "Vous n'êtes pas autorisé à accéder à ce DMP.");
          return false;
        }
        return true;
      } else {
        if (!doNotSendError) {
          yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type, "Vous n'êtes pas autorisé à accéder à ce DMP.");
        }
        return false;
      }
    }
  }
  if ([
    dmpCommandFailureContextualizedType(apiSections.DIRECT_AUTHENTICATION_DMP_STATUS_SECTION),
    dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION)
  ].includes(result.type)) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, result.data);
    return false;
  }
  
  return true;
}

function * handleGetCurrentDMPRemoteRequest (requestId, responseChannel, channelUrl, type) {
  const directAuthStatus = yield select(getDirectAuthenticationStatus);
  const response         = generateGetCurrentDmpResponse(requestId, directAuthStatus);
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  
  yield call(updateToast, requestId, toast.TYPE.SUCCESS);
}

function * handleFindDMPRemoteRequest (requestId, filters, responseChannel, channelUrl, type) {
  const { accessRights } = yield select(getAccessRights);
  if (!isTransactionAllowed(accessRights, transactions.FIND_PATIENTS) === true) {
    yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const params = type === remoteFormats.JSON
    ? extractJSONFindDmpParams(filters)
    : extractFindDmpParams(filters);
  
  yield put(remoteFindPatients(params));
  
  const result = yield take([
    dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_FIND_PATIENTS_SECTION),
    dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_FIND_PATIENTS_SECTION)
  ]);
  
  let response;
  if (result && result.type === dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_FIND_PATIENTS_SECTION)) {
    const { data: { Patients = [] } } = result;
    
    response = generateFindDmpResponse(requestId, Patients);
    
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  } else {
    // gestion erreur
    const { data: error } = result;
    response              = generateRemoteFailureResponse(requestId, error);
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
}

function * handleTestDmpExistenceRemoteRequest (requestId, confidentialityLevel, patient, responseChannel, channelUrl, type) {
  const { accessRights } = yield select(getAccessRights);
  if (!isTransactionAllowed(accessRights, transactions.AUTHORIZATION_CHECK) === true) {
    yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const params = getInsFromPatient(patient, type);
  
  if (!Object.values(insTypes).includes(params.insType.toUpperCase())) {
    yield call(handleInvalidInsTypeError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const { ins } = params;
  
  const secretConnection = yield select(getSecretConnection);

  if (confidentialityLevel !== -1) {
    yield call(handleSetConfidentialityLevel, {
      ins,
      confidentialityLevel
    });
    const confidentialityLevelResult = yield take([
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
    ]);

    if (
      confidentialityLevelResult
      && confidentialityLevelResult.type === dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
    ) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
      return;
    }
  }
  
  const { accessRights: { psId } } = yield select(getAccessRightsProps);
  const result                     = yield call(sendActionAndWaitResult, {
    func      : getAction(
      commands.getDirectAuthenticationDMPStatus,
      apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
      { s_ins: ins },
      {
        subSection   : `${ins}/${psId}`,
        contextParams: { ins, performer: psId },
        remote       : true
      }
    ),
    section   : apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
    subSection: `${ins}/${psId}`
  });
  
  let response;
  if (
    result
    && [
      dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION),
      dmpCommandSuccessContextualizedType(apiSections.DIRECT_AUTHENTICATION_DMP_STATUS_SECTION)
    ].includes(result.type)
  ) {
    const { data } = result;
    
    response = generateTestDmpExistenceResponse(requestId, data);
    
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  } else {
    // gestion erreur
    const { data: error } = result;
    response              = generateRemoteFailureResponse(requestId, error);
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(handleSetConfidentialityLevel, {
    ins,
    confidentialityLevel: Number(secretConnection)
  });
}

function * handleOpenDmp (requestId, confidentialityLevel, patient, responseChannel, channelUrl, type) {
  const { accessRights, accessRights: { psId, esId, authenticationType, airOnly } = {} } = yield select(getAccessRights);
  
  const params = type === remoteFormats.JSON ? extractJSONOpenDmp(patient) : extractOpenDmp(patient);
  
  if (!Object.values(insTypes).includes(params.insType.toUpperCase())) {
    yield call(handleInvalidInsTypeError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const secretConnection = yield select(getSecretConnection);
  
  const { ins, addAccessAuthorization, useBdgAccess, bdgAccessReason } = params;
  if (confidentialityLevel !== -1) {
    yield call(handleSetConfidentialityLevel, {
      ins,
      confidentialityLevel
    });
    const confidentialityLevelResult = yield take([
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
    ]);

    if (
      confidentialityLevelResult
      && confidentialityLevelResult.type === dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
    ) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
      return;
    }
  }
  
  const result = yield call(sendActionAndWaitResult, {
    func      : getAction(
      commands.getDirectAuthenticationDMPStatus,
      apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
      { s_ins: ins },
      {
        subSection   : `${ins}/${psId}`,
        contextParams: { ins, performer: psId },
        remote       : true
      }
    ),
    section   : apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
    subSection: `${ins}/${psId}`
  });
  
  let response;
  
  if (result && result.type === dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION)) {
    const {
            data: {
              ExistingTestAnswer: {
                i_dmpStatus        : dmpStatus,
                i_userAuthorization: authorization
                // AdminData: {
                //   s_patientGivenName: given,
                //   s_patientName: name,
                // } = {},
              } = {}
            }
          } = result;
    
    // dmp n'existe pas
    if (dmpStatus === dmpStatuses.DMPNotFound || dmpStatus === dmpStatuses.DMPIsClosed) {
      let extraInfos = "";
      if (dmpStatus === dmpStatuses.DMPNotFound) {
        extraInfos = "Aucun DMP associé à l’INS fourni.";
      }
      if (dmpStatus === dmpStatuses.DMPIsClosed) {
        extraInfos = "Le DMP associé à l’INS fourni est fermé";
      }
      yield call(
        handleError,
        requestId,
        responseChannel,
        channelUrl,
        type,
        {
          i_apiErrorType                : errorTypes.RemoteErrors,
          i_apiErrorCode                : "DMP_NOT_FOUND",
          s_apiErrorExtendedInformations: extraInfos
        }
      );
      return;
    }
    
    if (authorization !== userAuthorizationStatuses.AuthorizationExist) {
      if (addAccessAuthorization) {
        const ok = yield call(handleAddAuthorization, ins, psId, airOnly, authenticationType, esId, requestId, responseChannel, channelUrl, type);
        if (!ok) {
          yield call(handleSetConfidentialityLevel, {
            ins,
            secretConnection
          });
          return;
        }
      } else if (useBdgAccess && bdgAccessReason) {
        yield call(handleSetDmpAccessMode, { accessMode: accessModes.BrisDeGlace, accessModeReason: bdgAccessReason });
        const accessModeResult = yield take([
          dmpCommandSuccessContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION),
          dmpCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)
        ]);
        if (accessModeResult && accessModeResult.type === dmpRemoteCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)) {
          yield call(
            handleError,
            requestId,
            responseChannel,
            channelUrl,
            type,
            result.data
          );
          yield call(updateToast, requestId, toast.TYPE.ERROR);
          yield call(handleSetConfidentialityLevel, {
            ins                 : "all",
            confidentialityLevel: Number(secretConnection)
          });
          return;
        }
      }
    }
    
    // dmp déjà ouvert ?
    const currentPathname = yield select(getCurrentPathname);
    if (currentPathname.indexOf(`/dmp/${encodeIns(ins)}`) !== -1) {
      response = {
        "@RelatesTo": requestId,
        "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
      };
      yield call(updateToast, requestId, toast.TYPE.SUCCESS);
    } else {
      // yield put(remoteGetOpenDMPConsent({ name, given }, ins));
      // const consentAnswer = yield take(dmpconnectRemoteActionConstants.DMPC_REMOTE_ANSWER_OPEN_DMP_CONSENT);
      // const { consent } = consentAnswer;
      // if (!consent) {
      //   response = generateRemoteFailureResponse(requestId, {
      //     i_apiErrorType: errorTypes.RemoteErrors,
      //     i_apiErrorCode: 'REJECTED_BY_USER',
      //     s_apiErrorExtendedInformations: 'L’utilisateur a rejeté l’action demandée.',
      //   });
      //   yield call(updateToast, requestId, toast.TYPE.ERROR);
      // } else {
      yield put(selectINS(ins));
      
      const dmpLandingPage = yield select(getDmpLandingPage);
      const url            = getDocumentRedirectUrl(accessRights, ins, dmpLandingPage);
      yield put(push(url));
      
      response = {
        "@RelatesTo": requestId,
        "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
      };
      
      yield call(updateToast, requestId, toast.TYPE.SUCCESS);
      // }
    }
  } else {
    response = generateRemoteFailureResponse(requestId, result.data);
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
}

function * handleCloseDmpSession (requestId, responseChannel, channelUrl, type) {
  let response;
  
  const selectedINS = yield select(getSelectedINS);
  
  if (selectedINS && selectedINS !== -1) {
    // yield put(remoteGetCloseDMPConsent());
    // const consentAnswer = yield take(dmpconnectRemoteActionConstants.DMPC_REMOTE_ANSWER_CLOSE_DMP_CONSENT);
    // const { consent } = consentAnswer;
    // if (!consent) {
    //   response = generateRemoteFailureResponse(requestId, {
    //     i_apiErrorType: errorTypes.RemoteErrors,
    //     i_apiErrorCode: 'REJECTED_BY_USER',
    //     s_apiErrorExtendedInformations: 'L’utilisateur a rejeté l’action demandée.',
    //   });
    //   yield call(updateToast, requestId, toast.TYPE.ERROR);
    // } else {
    yield put(selectINS(null));
    yield put(push(`/home`));
    
    response = {
      "@RelatesTo": requestId,
      "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
    };
    
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
    // }
  } else {
    response = generateRemoteFailureResponse(requestId, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "DMP_NOT_CONNECTED",
      s_apiErrorExtendedInformations: "Pas de DMP ouvert"
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
}

function * handleSubmitDocument (requestId, confidentialityLevel, data, responseChannel, channelUrl, type) {
  yield put(clearRemoteSection(apiSections.REMOTE_SEND_DOCUMENT));
  yield put(clearRemoteSection(apiSections.REMOTE_SUBMIT_DOCUMENT));
  
  const { accessRights } = yield select(getAccessRights);
  if (!canUpload(accessRights)) {
    yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const secretConnection = yield select(getSecretConnection);
  
  const { params, visibility, insType } = type === remoteFormats.JSON
    ? extractJSONSubmitDocumentParams(data)
    : extractSubmitDocumentParams(data);
  
  if (Number(params.sendInBackground) === 1 || params.sendInBackground === true) {
    if (Number(params.modal) === 1 || params.modal === true) {
      yield put(toggleLoadingBackdrop(true, params.modalMessage || "Traitement d'une commande en cours"));
    }
  }
  
  // check cumul de visibilité
  const { i_cumulMasquePsPatient, i_minorFunctionManagement } = yield select(getDmpParameterFromState);
  if (
    (visibility.invisiblePatient && visibility.masquePS && i_cumulMasquePsPatient === 0)
    || (visibility.invisibleRepresentant && visibility.masquePS && i_minorFunctionManagement === 0)
  ) {
    const i_apiErrorCode               = "BAD_CONFIDENTIALITY";
    let s_apiErrorExtendedInformations = "Impossible de définir ce niveau de confidentialité pour le document. ";
    if (visibility.invisiblePatient && visibility.masquePS && i_cumulMasquePsPatient === 0) {
      s_apiErrorExtendedInformations += "masquePS et invisiblePatient définis conjointement à vrai. ";
    }
    if (visibility.invisibleRepresentant && visibility.masquePS && i_minorFunctionManagement === 0) {
      s_apiErrorExtendedInformations = "masquePS et invisibleRepresentant définis conjointement à vrai).";
    }
    yield call(
      handleError,
      requestId,
      responseChannel,
      channelUrl,
      type,
      {
        i_apiErrorType: errorTypes.RemoteErrors,
        i_apiErrorCode,
        s_apiErrorExtendedInformations
      }
    );
    yield call(updateToast, requestId, toast.TYPE.ERROR);
    return;
  }
  
  const fileType = yield call(FileType.fromBuffer, base64ToArrayBuffer(params.base64));
  if (fileType) {
    const mismatch = (
      (fileType.mime === "application/xml" && ![...documentFormatsCda, documentFormats.textPlain].includes(params.documentFormat))
      || (fileType.mime !== "application/xml" && fileType.mime !== documentFormatTypeMimes[params.documentFormat])
    );
    
    if (mismatch && params.documentFormat !== documentFormats.kos) {
      yield call(
        handleError,
        requestId,
        responseChannel,
        channelUrl,
        type,
        {
          i_apiErrorType                : errorTypes.RemoteErrors,
          i_apiErrorCode                : "INVALID_FORMAT",
          s_apiErrorExtendedInformations: "Le contenu du document ne correspond pas au format de document fourni."
        }
      );
      yield call(updateToast, requestId, toast.TYPE.ERROR);
      return;
    }
  }
  
  if (Number(params.sendInBackground) === 1 || params.sendInBackground === true || documentFormatsCda.includes(params.documentFormat)) {
    if (!params.creationDate) {
      params.creationDate = moment().format("DD/MM/YYYY");
    }
    if (!params.serviceStartDate) {
      params.serviceStartDate = moment().format("DD/MM/YYYY");
    }
    if (!params.serviceStopDate) {
      params.serviceStopDate = moment().format("DD/MM/YYYY");
    }
  }
  
  // check structured docs
  if (documentFormatsCda.includes(params.documentFormat)) {
    
    yield put(remoteValidateCDADocuments(requestId, params));
    const document = yield take([
      dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_VALIDATE_DOCUMENT),
      dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_VALIDATE_DOCUMENT)
    ]);
    
    if (document.type === dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_VALIDATE_DOCUMENT)) {
      const { Documents }                                                        = document.data;
      const { s_contentInBase64, s_cdaHeadersInBase64, s_cdaInBase64, DicomKos } = Documents[0];
      Object.assign(params, {
        DicomKos,
        structuredHtml   : s_contentInBase64,
        structuredHeader : s_cdaHeadersInBase64,
        stylesheetApplied: hasCustomStyleSheetApplied(s_cdaInBase64)
      });
    } else {
      let errorExtendInfo = "Invalid cda content";
      let details;
      if (document.data.s_apiErrorDescription) {
        errorExtendInfo = document.data.s_apiErrorDescription;
        details         = document.data.s_apiErrorExtendedInformations;
      }
      yield call(
        handleError,
        requestId,
        responseChannel,
        channelUrl,
        type,
        {
          i_apiErrorType                : errorTypes.RemoteErrors,
          i_apiErrorCode                : "INVALID_FORMAT",
          s_apiErrorExtendedInformations: errorExtendInfo
        },
        details
      );
      yield call(updateToast, requestId, toast.TYPE.ERROR);
      return;
    }
  }
  
  if (!Object.values(insTypes).includes(insType.toUpperCase())) {
    yield call(handleInvalidInsTypeError, requestId, responseChannel, channelUrl, type);
    return;
  }
  if (confidentialityLevel !== -1) {
    yield call(handleSetConfidentialityLevel, {
      ins: params.ins,
      confidentialityLevel
    });
    const confidentialityLevelResult = yield take([
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
    ]);

    if (
      confidentialityLevelResult
      && confidentialityLevelResult.type === dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
    ) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
      return;
    }
  }
  
  let response;
  
  if (!params.Identity) {
    const { accessRights: { psId } } = yield select(getAccessRightsProps);
    
    const result = yield call(sendActionAndWaitResult, {
      func      : getAction(
        commands.getDirectAuthenticationDMPStatus,
        apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
        { s_ins: params.ins },
        {
          subSection   : `${params.ins}/${psId}`,
          contextParams: { ins: params.ins, performer: psId },
          remote       : true
        }
      ),
      section   : apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
      subSection: `${params.ins}/${psId}`
    });
    
    // vérifier l'autorisation d'accès
    const {
            data: {
              ExistingTestAnswer: {
                i_dmpStatus: dmpStatus
              } = {}
            }
          } = result;
    
    // dmp n'existe pas
    if (isReady(result.data) && dmpStatus !== dmpStatuses.DMPExist) {
      yield call(handleDMPNotFoundError, requestId, responseChannel, channelUrl, type);
      yield call(handleSetConfidentialityLevel, {
        ins                 : "all",
        confidentialityLevel: Number(secretConnection)
      });
      return;
    }
    if ([
      dmpCommandFailureContextualizedType(apiSections.DIRECT_AUTHENTICATION_DMP_STATUS_SECTION),
      dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION)
    ].includes(result.type)) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, result.data);
      yield call(handleSetConfidentialityLevel, {
        ins                 : "all",
        confidentialityLevel: Number(secretConnection)
      });
      return;
    }
  }
  
  if (Number(params.sendInBackground) === 1 || params.sendInBackground === true) {
    const {
            forceSchematronsValidation,
            ignorePdfA1Transparency,
            disabledPdfA1Conversion
          } = yield select(getDocumentOptions);
    
    const {
            typeCode,
            data: base64Content,
            title,
            description,
            format,
            documentVisibility,
            healthcareSetting,
            creationDate,
            replaceDocumentId,
            serviceStartDate,
            serviceStopDate,
            setIdRoot,
            setIdExtension,
            versionNumber
          } = formatUploadDocumentParams(params);
    
    yield put(remoteSendDocument({
      ins: params.ins,
      
      base64Content,
      stylesheetBase64  : params.stylesheetBase64,
      title,
      description,
      category          : typeCode,
      visibility        : documentVisibility,
      format,
      healthcareSetting,
      creationDate,
      serviceStartDate,
      serviceStopDate,
      replacedDocumentId: replaceDocumentId,
      setIdRoot,
      setIdExtension,
      versionNumber,
      
      eventCodes        : params.eventCodes,
      Informants        : params.informants,
      Performer         : params.performer,
      TreatingPhycisian : params.treatingPhysician,
      AdditionalAuthors : params.additionalAuthors,
      IntendedRecipients: params.intendedRecipients,
      
      retrieveDocumentUuid: params.retrieveDocumentUuid,
      getDocumentContent  : params.getDocumentContent,
      
      uniqueId: params.uniqueId,
      Identity: params.Identity,
      
      forceSchematronsValidation,
      ignorePdfA1Transparency: params.ignorePdfA1Transparency !== undefined ? params.ignorePdfA1Transparency : ignorePdfA1Transparency,
      disabledPdfA1Conversion: params.disabledPdfA1Conversion !== undefined ? params.disabledPdfA1Conversion : disabledPdfA1Conversion,
      
      submitEngine                : params.submitEngine,
      AdditionalPatientIdentifiers: params.AdditionalPatientIdentifiers,
      unMapped                    : params.unMapped
    }));
  } else {
    yield put(remoteSubmitDoc(requestId, params));
  }
  
  const resultSubmit = yield take([
    dmpconnectRemoteActionConstants.DMPC_REMOTE_SUBMIT_DOC_REFUSE,
    dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_SEND_DOCUMENT),
    dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_SEND_DOCUMENT)
  ]);
  
  if (resultSubmit && resultSubmit.type === dmpconnectRemoteActionConstants.DMPC_REMOTE_SUBMIT_DOC_REFUSE) {
    response = generateRemoteFailureResponse(requestId, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "REJECTED_BY_USER",
      s_apiErrorExtendedInformations: "L’utilisateur a rejeté l’action demandée."
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  } else if (resultSubmit && resultSubmit.type === dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_SEND_DOCUMENT)) {
    const {
            data: {
              s_uniqueId, s_uuid, UniqueIds, Uuids, DocumentContent
            }
          }        = resultSubmit;
    const uniqueId = s_uniqueId || (UniqueIds && UniqueIds.length > 0 ? UniqueIds[0] : undefined);
    const uuid     = s_uuid || (Uuids && Uuids.length > 0 ? Uuids[0] : undefined);
    
    response = {
      "@RelatesTo": requestId,
      "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success",
      document    : {
        uniqueId,
        uuid,
        cdaContent: DocumentContent ? rename(DocumentContent, key => key.replace(/^s_|^i_/, "")) : undefined
      }
    };
    
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  } else {
    const { data: error } = resultSubmit;
    response              = generateRemoteFailureResponse(requestId, error);
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  
  yield put(remoteSubmitDoc(null, null));
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(handleSetConfidentialityLevel, {
    ins                 : "all",
    confidentialityLevel: Number(secretConnection)
  });
  if (Number(params.modal) === 1 || params.modal === true) {
    yield put(toggleLoadingBackdrop(false, ""));
  }
}

function * checkDocument (document, index, requestId) {
  const
    {
      invisiblePatient,
      masquePS,
      invisibleRepresentant
    } = document;
  
  const visibility = {
    invisiblePatient,
    masquePS,
    invisibleRepresentant
  };
  
  // check cumul de visibilité
  const { i_cumulMasquePsPatient, i_minorFunctionManagement } = yield select(getDmpParameterFromState);
  if (
    (visibility.invisiblePatient && visibility.masquePS && i_cumulMasquePsPatient === 0)
    || (visibility.invisibleRepresentant && visibility.masquePS && i_minorFunctionManagement === 0)
  ) {
    const i_apiErrorCode               = "BAD_CONFIDENTIALITY";
    let s_apiErrorExtendedInformations = `Impossible de définir ce niveau de confidentialité pour le document [${index}].`;
    if (visibility.invisiblePatient && visibility.masquePS && i_cumulMasquePsPatient === 0) {
      s_apiErrorExtendedInformations += "masquePS et invisiblePatient définis conjointement à vrai. ";
    }
    if (visibility.invisibleRepresentant && visibility.masquePS && i_minorFunctionManagement === 0) {
      s_apiErrorExtendedInformations = "masquePS et invisibleRepresentant définis conjointement à vrai).";
    }
    
    return {
      i_apiErrorType: errorTypes.RemoteErrors,
      i_apiErrorCode,
      s_apiErrorExtendedInformations
    };
  }
  
  const fileType = yield call(FileType.fromBuffer, base64ToArrayBuffer(document.base64));
  if (fileType) {
    const mismatch = (
      (fileType.mime === "application/xml" && ![...documentFormatsCda, documentFormats.textPlain].includes(document.documentFormat))
      || (fileType.mime !== "application/xml" && fileType.mime !== documentFormatTypeMimes[document.documentFormat])
    );
    
    if (mismatch && document.documentFormat !== documentFormats.kos) {
      return {
        i_apiErrorType                : errorTypes.RemoteErrors,
        i_apiErrorCode                : "INVALID_FORMAT",
        s_apiErrorExtendedInformations: `Le contenu du document [${index}] ne correspond pas au format de document fourni.`
      };
    }
  }
  
  // check structured docs
  // if (documentFormatsCda.includes(document.documentFormat)) {
  //   yield put(remoteValidateCDADocuments(requestId, document));
  //   const document = yield take([
  //     dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_VALIDATE_DOCUMENT),
  //     dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_VALIDATE_DOCUMENT),
  //   ]);
  //
  //   if (document.type === dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_VALIDATE_DOCUMENT)) {
  //     // const { Documents }                                              = document.data;
  //     // const { s_contentInBase64, s_cdaHeadersInBase64, s_cdaInBase64 } = Documents[0];
  //     // Object.assign(document, {
  //     //   structuredHtml   : s_contentInBase64,
  //     //   structuredHeader : s_cdaHeadersInBase64,
  //     //   stylesheetApplied: hasCustomStyleSheetApplied(s_cdaInBase64),
  //     // });
  //     return undefined;
  //   } else {
  //     let errorExtendInfo = 'Invalid cda content';
  //     // let details;
  //     if (document.data.s_apiErrorDescription) {
  //       errorExtendInfo = document.data.s_apiErrorDescription;
  //       // details         = document.data.s_apiErrorExtendedInformations;
  //     }
  //
  //     return {
  //       i_apiErrorType                : errorTypes.RemoteErrors,
  //       i_apiErrorCode                : 'INVALID_FORMAT',
  //       s_apiErrorExtendedInformations: errorExtendInfo,
  //     };
  //   }
  // }
  
  return undefined;
}

function * handleSendSubmissionSet (requestId, confidentialityLevel, data, responseChannel, channelUrl, type) {
  yield put(clearRemoteSection(apiSections.REMOTE_SEND_DOCUMENT));
  yield put(clearRemoteSection(apiSections.REMOTE_SUBMIT_DOCUMENT));
  
  const { accessRights } = yield select(getAccessRights);
  if (!canUpload(accessRights)) {
    yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const secretConnection = yield select(getSecretConnection);
  
  // const { params, visibility, insType } = type === remoteFormats.JSON
  //                                         ? extractJSONSubmitDocumentsParams(data)
  //                                         : extractSubmitDocumentsParams(data);
  
  const { params, insType } = extractJSONSendSubmissionSetParams(data);
  
  if (Number(params.sendInBackground) === 1 || params.sendInBackground === true) {
    if (Number(params.modal) === 1 || params.modal === true) {
      yield put(toggleLoadingBackdrop(true, params.modalMessage || "Traitement d'une commande en cours"));
    }
  }
  
  const errors         = yield all(params.documents.map((doc, index) => call(checkDocument, doc, index, requestId)));
  const filteredErrors = errors.filter(err => err !== undefined);
  
  if (filteredErrors && filteredErrors.length > 0) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, filteredErrors);
    return;
  }
  
  if (!Object.values(insTypes).includes(insType.toUpperCase())) {
    yield call(handleInvalidInsTypeError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  yield put(getAction(
    commands.setConfidentialityLevel,
    apiSections.CONFIDENTIALITY_LEVEL_SECTION,
    { i_enableSecretConnection: Number(confidentialityLevel) },
    { subSection: params.ins }
  ));
  const confidentialityLevelResult = yield take([
    dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
    dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
    dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
  ]);
  
  if (
    confidentialityLevelResult
    && confidentialityLevelResult.type === dmpRemoteCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
  ) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
    return;
  }
  
  let response;
  
  if (!params.Identity) {
    const { accessRights: { psId } } = yield select(getAccessRightsProps);
    
    const result = yield call(sendActionAndWaitResult, {
      func      : getAction(
        commands.getDirectAuthenticationDMPStatus,
        apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
        { s_ins: params.ins },
        {
          subSection   : `${params.ins}/${psId}`,
          contextParams: { ins: params.ins, performer: psId },
          remote       : true
        }
      ),
      section   : apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION,
      subSection: `${params.ins}/${psId}`
    });
    
    // vérifier l'autorisation d'accès
    const {
            data: {
              ExistingTestAnswer: {
                i_dmpStatus: dmpStatus
              } = {}
            }
          } = result;
    
    // dmp n'existe pas
    if (isReady(result.data) && dmpStatus !== dmpStatuses.DMPExist) {
      yield call(handleDMPNotFoundError, requestId, responseChannel, channelUrl, type);
      yield put(getAction(
        commands.setConfidentialityLevel,
        apiSections.CONFIDENTIALITY_LEVEL_SECTION,
        { i_enableSecretConnection: Number(secretConnection) },
        { subSection: "all" }
      ));
      return;
    }
    if ([
      dmpCommandFailureContextualizedType(apiSections.DIRECT_AUTHENTICATION_DMP_STATUS_SECTION),
      dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION)
    ].includes(result.type)) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, result.data);
      yield put(getAction(
        commands.setConfidentialityLevel,
        apiSections.CONFIDENTIALITY_LEVEL_SECTION,
        { i_enableSecretConnection: Number(secretConnection) },
        { subSection: "all" }
      ));
      return;
    }
  }
  
  const apiType = yield select(getApiType);
  let performer;
  if (apiType !== API_TYPES.REST) {
    performer = {
      Hp: {
        i_hpAuthenticationMode: 15,
        s_hpGiven             : accessRights.given,
        s_hpName              : accessRights.name,
        s_hpInternalId        : accessRights.psId,
        s_hpProfession        : accessRights.profession,
        s_hpProfessionOid     : accessRights.professionOid,
        s_hpSpecialty         : accessRights.specialty
      }
    };
  }
  // if (Number(params.sendInBackground) === 1 || params.sendInBackground === true) {
  const {
          forceSchematronsValidation,
          ignorePdfA1Transparency,
          disabledPdfA1Conversion
        }      = yield select(getDocumentOptions);
  const esUser = yield select(getEsUser);
  yield put(getAction(
    commands.sendSubmissionSet,
    apiSections.REMOTE_SEND_SUBMISSION_SET,
    {
      ins                         : params.ins,
      retrieveDocumentUuid        : params.retrieveDocumentUuid,
      getDocumentContent          : params.getDocumentContent,
      forceSchematronsValidation,
      ignorePdfA1Transparency     : params.ignorePdfA1Transparency !== undefined ? params.ignorePdfA1Transparency : ignorePdfA1Transparency,
      disabledPdfA1Conversion     : params.disabledPdfA1Conversion !== undefined ? params.disabledPdfA1Conversion : disabledPdfA1Conversion,
      AdditionalPatientIdentifiers: params.AdditionalPatientIdentifiers,
      Identity                    : params.Identity,
      esUser,
      submitEngine                : params.submitEngine,
      healthcareSetting           : params.healthcareSetting,
      
      Documents: params.documents.map(doc => {
        const
          {
            format,
            data,
            structuredBody
          } = getFormatAndContent(doc);
        
        if (!doc.creationDate) {
          doc.creationDate = moment().format("DD/MM/YYYY");
        }
        if (!doc.serviceStartDate) {
          doc.serviceStartDate = moment().format("DD/MM/YYYY");
        }
        if (!doc.serviceStopDate) {
          doc.serviceStopDate = moment().format("DD/MM/YYYY");
        }
        
        return {
          typeCode                : doc.typeCode,
          base64Content           : data,
          pdfCopyContentInBase64  : doc.pdfCopyContentInBase64,
          stylesheetBase64        : doc.stylesheetBase64,
          structuredBody,
          title                   : doc.title,
          description             : doc.description,
          format,
          healthcareSetting       : doc.healthcareSetting,
          creationDate            : doc.creationDate,
          serviceStartDate        : doc.serviceStartDate,
          serviceStopDate         : doc.serviceStopDate,
          replacedDocumentUniqueId: doc.replacedDocumentUniqueId,
          versionNumber           : doc.versionNumber,
          setIdRoot               : doc.setIdRoot,
          setIdExtension          : doc.setIdExtension,
          eventCodes              : doc.eventCodes,
          AdditionalAuthors       : doc.additionalAuthors,
          Informants              : doc.informants,
          IntendedRecipients      : doc.intendedRecipients,
          TreatingPhysician       : doc.treatingPhysician,
          Performer               : doc.performer || performer,
          visibility              : calculateVisibility(
            doc.invisiblePatient,
            doc.masquePS,
            doc.invisibleRepresentantLegal,
            true
          )
        };
      })
    },
    { remote: true }
  ));
  
  // }
  
  // else {
  //   yield put(remoteSubmitDoc(requestId, params));
  // }
  
  const resultSubmit = yield take([
    dmpconnectRemoteActionConstants.DMPC_REMOTE_SUBMIT_DOC_REFUSE,
    dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_SEND_SUBMISSION_SET),
    dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_SEND_SUBMISSION_SET)
  ]);
  
  if (resultSubmit && resultSubmit.type === dmpconnectRemoteActionConstants.DMPC_REMOTE_SUBMIT_DOC_REFUSE) {
    response = generateRemoteFailureResponse(requestId, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "REJECTED_BY_USER",
      s_apiErrorExtendedInformations: "L’utilisateur a rejeté l’action demandée."
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  } else if (resultSubmit && resultSubmit.type === dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_SEND_SUBMISSION_SET)) {
    const {
            data: {
              UniqueIds = [], Uuids = [], DocumentsContent = []
            }
          } = resultSubmit;
    
    response = {
      "@RelatesTo": requestId,
      "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success",
      documents   : UniqueIds.map((uniqueId, index) => ({
        uniqueId       : uniqueId,
        uuid           : Uuids[index],
        documentContent: DocumentsContent[index]
      }))
    };
    
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  } else {
    const { data: error } = resultSubmit;
    response              = generateRemoteFailureResponse(requestId, error);
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  
  yield put(remoteSubmitDoc(null, null));
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield put(getAction(
    commands.setConfidentialityLevel,
    apiSections.CONFIDENTIALITY_LEVEL_SECTION,
    { i_enableSecretConnection: Number(secretConnection) },
    { subSection: "all" }
  ));
  if (Number(params.modal) === 1 || params.modal === true) {
    yield put(toggleLoadingBackdrop(false, ""));
  }
}

function * handleDeleteDocument (requestId, confidentialityLevel, data, responseChannel, channelUrl, type) {
  const secretConnection = yield select(getSecretConnection);
  
  const {
          ins, uniqueId, uuid, practice, submitEngine
        } = type === remoteFormats.JSON ? extractJSONDeleteDocumentParams(data) : extractDeleteDocumentParams(data);

  if (confidentialityLevel !== -1) {
    yield call(handleSetConfidentialityLevel, {
      ins,
      confidentialityLevel
    });
    const confidentialityLevelResult = yield take([
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
    ]);

    if (
      confidentialityLevelResult
      && confidentialityLevelResult.type === dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
    ) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
      return;
    }
  }
  
  yield put(remoteDeleteDocument(formatDeleteDocumentParams(uniqueId, uuid, ins, practice, submitEngine)));
  const deleteResult = yield take([
    dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_DELETE_DOCUMENT),
    dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_DELETE_DOCUMENT)
  ]);
  
  let response;
  if (deleteResult && deleteResult.type === dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_DELETE_DOCUMENT)) {
    response = {
      "@RelatesTo": requestId,
      "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
    };
    
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  } else {
    const { data: error } = deleteResult;
    response              = generateRemoteFailureResponse(requestId, error);
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(handleSetConfidentialityLevel, {
    ins                 : "all",
    confidentialityLevel: Number(secretConnection)
  });
}

function * handleGetCertifiedIdentity (requestId, confidentialityLevel, data, responseChannel, channelUrl, type) {
  const { accessRights } = yield select(getAccessRights);
  if (!isTransactionAllowed(accessRights, transactions.CERTIFIED_IDENTITY) === true) {
    yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const params = type === remoteFormats.JSON ? extractJSONGetCertifiedIdentityParams(data) : extractGetCertifiedIdentityParams(data);
  
  if (!Object.values(insTypes).includes(params.insType.toUpperCase())) {
    yield call(handleInvalidInsTypeError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  let response;
  const secretConnection = yield select(getSecretConnection);
  
  if (params === false) {
    response = generateRemoteFailureResponse(requestId, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "NOT_ENOUGH_PARAMS",
      s_apiErrorExtendedInformations: "Nombre de paramètres insuffisant."
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  } else {
    if (confidentialityLevel !== -1) {
      yield call(handleSetConfidentialityLevel, {
        ins: params.ins,
        confidentialityLevel
      });
      const confidentialityLevelResult = yield take([
        dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
        dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
        dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
      ]);

      if (
        confidentialityLevelResult
        && confidentialityLevelResult.type === dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
      ) {
        yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
        return;
      }
    }
    
    yield put(remoteGetCertifiedIdentity(params));
    
    const result = yield take([
      dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_CERTIFIFIED_IDENTITY_SECTION),
      dmpRemoteCommandFailureContextualizedType(apiSections.REMOTE_CERTIFIFIED_IDENTITY_SECTION)
    ]);
    
    if (result && result.type === dmpRemoteCommandSuccessContextualizedType(apiSections.REMOTE_CERTIFIFIED_IDENTITY_SECTION)) {
      const { data: resultData = {} } = result;
      
      response = generateGetCertifiedIdentityResponse(requestId, resultData);
      
      yield call(updateToast, requestId, toast.TYPE.SUCCESS);
    } else {
      const { data: error } = result;
      response              = generateRemoteFailureResponse(requestId, error);
      yield call(updateToast, requestId, toast.TYPE.ERROR);
    }
  }
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  yield call(handleSetConfidentialityLevel, {
    ins                 : "all",
    confidentialityLevel: Number(secretConnection)
  });
}

function * handleGetEfficienceVersion (requestId, responseChannel, channelUrl, type) {
  const response = generateGetEfficienceVersionResponse(requestId);
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  
  yield call(updateToast, requestId, toast.TYPE.SUCCESS);
}

function * handleGetStatus (requestId, responseChannel, channelUrl, type) {
  const isLoggedIn        = yield select(isUserLoggedInAccessor);
  const mssActive         = yield select(isMssActive);
  const mssEmail          = yield select(getMssEmail);
  const esUser            = yield select(getEsUser);
  const practiceSetting   = yield select(getPracticeSetting);
  const healthcareSetting = yield select(getHealthcareSetting);
  
  const directAuthStatus = yield select(getDirectAuthenticationStatus);
  
  const { accessRights: { psId, authenticationType } } = yield select(getAccessRightsProps);
  const definedPracticeLocation                        = yield select(extractPracticeLocationFromState, psId);
  
  const readers = yield select((state) => {
    const { dmpconnect: { [apiSections.PCSC_READERS_SECTION]: { Readers = [] } = {} } = {} } = state;
    return Readers;
  });
  
  let response = {
    "@RelatesTo": requestId,
    "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success",
    version     : env.REACT_APP_VERSION,
    hpConnected : type === remoteFormats.JSON ? isLoggedIn : String(isLoggedIn),
    mss         : {
      active: !!mssActive,
      email : mssEmail
    }
  };
  
  if (readers && readers.length > 0) {
    response = {
      ...response,
      readers: readers.map(r => ({
        name                 : r.s_name,
        accessMode           : Number(r.i_accessMode),
        accessModeDescription: r.s_accessMode,
        cardType             : r.i_slotType,
        cardTypeDescription  : r.s_slotType
      }))
    };
  }
  
  if (isLoggedIn) {
    if (authenticationType === authenticationTypes.DIRECT) {
      response = {
        ...response,
        hpInfos: isLoggedIn
          ? {
            rpps: psId,
            practiceSetting,
            healthcareSetting,
            ...definedPracticeLocation
          }
          : undefined
      };
    } else {
      response = {
        ...response,
        hpInfos: {
          ...esUser,
          practiceSetting,
          healthcareSetting
        }
      };
    }
    
    response = { ...response, currentDmp: { ...generateGetCurrentDmpBody(requestId, directAuthStatus) } };
  }
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  
  yield call(updateToast, requestId, toast.TYPE.SUCCESS);
}

function getMssSendEmailParams (state) {
  const {
          dmpconnectUser: { esUser },
          dmpconnectESConfiguration
        } = state;
  
  return {
    hpAuthenticationMode: getConfigurationValue("hpAuthenticationMode", dmpconnectESConfiguration) || 8,
    apiType             : getApiType(state),
    esUser,
    healthcareSetting   : getHealthcareSetting(state),
    ...getDocumentOptions(state)
  };
}

const getMssFolders = (state, email) => {
  const {
          mssMessages: {
            [email]: {
              MssFolders = []
            } = {}
          } = {}
        } = state;
  return MssFolders;
};

export const verifyJwtPromise = token => new Promise((resolve) => {
  const client = JwksClient({
    jwksUri: env.REACT_APP_ES_LOGIN_OPENID_JWKS_ENDPOINT
  });
  
  const getKey = (header, callback) => {
    client.getSigningKey(header.kid, (err, key) => {
      let signingKey;
      if ("publicKey" in key) {
        signingKey = key.publicKey;
      }
      if ("rsaPublicKey" in key) {
        signingKey = key.rsaPublicKey;
      }
      callback(null, signingKey);
    });
  };
  
  jwt.verify(token, getKey, (err, decoded) => {
    resolve({ err, decoded });
  });
});

function * handleGetMssNbUnreadMessages (requestId, request, responseChannel, channelUrl, type) {
  const mssActive = yield select(isMssActive);
  
  let response;
  
  if (!mssActive) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "REFUSED_ACTION",
      s_apiErrorExtendedInformations: "Le module MSS n'est pas activé"
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
    yield put(toggleLoadingBackdrop(false, ""));
    return;
  }
  
  const params = type === remoteFormats.JSON
    ? extractJSONGetMssNbUnreadMessagesParams(request)
    : extractGetMssNbUnreadMessagesParams(request);
  
  const accountConfig = yield select(getMssAccountConfigByEmail, params.mssAccount);
  
  if (!accountConfig || Object.keys(accountConfig).length === 0) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "REFUSED_ACTION",
      s_apiErrorExtendedInformations: "L'adresse email de l'utilisateur n'est pas configurée"
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
    yield put(toggleLoadingBackdrop(false, ""));
    return;
  }
  const { mssLoginType, mssApiType, mssEmail: mssEmailConfig } = accountConfig;
  
  const mssPscAccessToken      = yield select(({ dmpconnectMSSConfiguration }) => dmpconnectMSSConfiguration.mssPscAccessToken);
  const externalPscAccessToken = yield select(({ dmpConnectPersistedAppConfiguration }) => dmpConnectPersistedAppConfiguration.externalPscAccessToken);
  if (externalPscAccessToken === true && mssLoginType === mssLoginTypes.PSC) {
    const { err } = yield call(verifyJwtPromise, mssPscAccessToken);
    
    if (err) {
      yield call(
        handleError,
        requestId,
        responseChannel,
        channelUrl,
        type,
        {
          i_apiErrorType: errorTypes.RemoteErrors,
          i_apiErrorCode: "REFUSED_ACTION"
        },
        [{ ...err }]
      );
      yield call(updateToast, requestId, toast.TYPE.ERROR);
      yield put(toggleLoadingBackdrop(false, ""));
      yield put(setMssConfiguration("mssPscAccessToken", ""));
      yield put(sendRemoteOutMessage({
        request: {
          "@data": "pscAccessToken",
          "@id"  : `{${generateUniqueId().toUpperCase()}}`,
          details: [{ ...err }]
        }
      }));
      return;
    }
  }
  
  // get INBOX folder content
  let mssFolders = yield select(getMssFolders, mssEmailConfig);
  
  if (!mssFolders || mssFolders.length === 0) {
    // get folders
    yield put(getAction(
      commands.getFoldersMSS,
      apiSections.MSS_GET_FOLDERS,
      mssEmailConfig,
      {
        subConfig   : mssApiType,
        contextExtra: { mssApiType, forceAction: errorActions.NONE, mssEmailConfig: mssEmailConfig },
        synchronous : true
      }
    ));
    
    const foldersResults = yield take([
      dmpconnectConfigurationActionConstants.DMPC_SET_PERSIST_APP_MSS_FOLDERS,
      dmpCommandFailureContextualizedType(apiSections.MSS_GET_FOLDERS)
    ]);
    if (foldersResults.type === dmpconnectConfigurationActionConstants.DMPC_SET_PERSIST_APP_MSS_FOLDERS) {
      mssFolders = yield select(getMssFolders, mssEmailConfig);
    } else {
      response = generateRemoteFailureResponse(
        requestId,
        {
          i_apiErrorType                : errorTypes.MssErrors,
          s_apiErrorExtendedInformations: "Impossible de récupérer les dossiers de la boite mail"
        },
        foldersResults
      );
      yield call(updateToast, requestId, toast.TYPE.ERROR);
    }
  }
  
  let inbox = mssFolders.find(f => f.type === mssFolderTypes.INBOX);
  if (params.folderId) {
    inbox = mssFolders.find(f => String(f.id) === (mssApiType === mssSubTypes.IMAP
      ? imapUtf7Encode(params.folderId)
      : String(params.folderId)));
  }
  
  if (inbox) {
    yield put(getAction(
      commands.getSearchMessagesMSS,
      apiSections.MSS_SEARCH_MESSAGES,
      { email: mssEmailConfig, folderId: inbox.id },
      {
        synchronous : true,
        subSection  : inbox.id,
        subConfig   : mssApiType,
        contextExtra: { mssApiType, forceAction: errorActions.NONE }
      }
    ));
    let result;
    while (result === undefined) {
      const searchResult = yield take([
        dmpconnectConfigurationActionConstants.DMPC_SET_PERSIST_APP_MSS_SYNCMESSAGES,
        dmpCommandFailureContextualizedType(apiSections.MSS_SEARCH_MESSAGES)
      ]);
      
      const {
              context : { subSection } = {}, // in case of dmpCommandFailureContextualizedType(apiSections.MSS_SEARCH_MESSAGES)
              messages: { folderId }   = {} // in case of dmpconnectConfigurationActionConstants.DMPC_SET_PERSIST_APP_MSS_SYNCMESSAGES
            } = searchResult;
      
      if (subSection === inbox.id || folderId === inbox.id) {
        result = searchResult;
      }
    }
    
    if (result.type === dmpconnectConfigurationActionConstants.DMPC_SET_PERSIST_APP_MSS_SYNCMESSAGES) {
      const { messages: { modifiedMessages = [], allMessages = [] } } = result;
      const unreadMessages                                            = [...modifiedMessages, ...allMessages].filter((message) => {
        const { flags: { unread = false } = {} } = message;
        return unread;
      });
      
      response = {
        "@RelatesTo"  : requestId,
        "@status"     : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success",
        email         : mssEmailConfig,
        unreadMessages: unreadMessages.length
      };
      yield call(updateToast, requestId, toast.TYPE.SUCCESS);
    } else {
      response = generateRemoteFailureResponse(requestId, result.data);
      yield call(updateToast, requestId, toast.TYPE.ERROR);
    }
  }
  
  yield call(sendResponse, response, responseChannel, channelUrl, type);
}

function * handleSendMssMessage (requestId, request, responseChannel, channelUrl, type) {
  const mssActive = yield select(isMssActive);
  let response;
  
  if (!mssActive) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "REFUSED_ACTION",
      s_apiErrorExtendedInformations: "Le module MSS n'est pas activé"
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
    yield put(toggleLoadingBackdrop(false, ""));
    return;
  }
  
  const params = type === remoteFormats.JSON
    ? extractJSONSendMssMessageParams(request)
    : extractSendMssMessageParams(request);
  
  const accountConfig = yield select(getMssAccountConfigByEmail, params.mssAccount);
  
  if (!accountConfig || Object.keys(accountConfig).length === 0) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "REFUSED_ACTION",
      s_apiErrorExtendedInformations: "L'adresse email de l'utilisateur n'est pas configurée"
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
    yield put(toggleLoadingBackdrop(false, ""));
    return;
  }
  const { mssLoginType, mssApiType, mssEmail: mssEmailConfig, mssReplyTo, mssSenderWording } = accountConfig;
  
  const mssPscAccessToken      = yield select(({ dmpconnectMSSConfiguration }) => dmpconnectMSSConfiguration.mssPscAccessToken);
  const externalPscAccessToken = yield select(({ dmpConnectPersistedAppConfiguration }) => dmpConnectPersistedAppConfiguration.externalPscAccessToken);
  if (externalPscAccessToken === true && mssLoginType === mssLoginTypes.PSC) {
    const { err } = yield call(verifyJwtPromise, mssPscAccessToken);
    
    if (err) {
      yield call(
        handleError,
        requestId,
        responseChannel,
        channelUrl,
        type,
        {
          i_apiErrorType: errorTypes.RemoteErrors,
          i_apiErrorCode: "REFUSED_ACTION"
        },
        [{ ...err }]
      );
      yield call(updateToast, requestId, toast.TYPE.ERROR);
      yield put(toggleLoadingBackdrop(false, ""));
      yield put(setMssConfiguration("mssPscAccessToken", ""));
      yield put(sendRemoteOutMessage({
        request: {
          "@data": "pscAccessToken",
          "@id"  : `{${generateUniqueId().toUpperCase()}}`,
          details: [{ ...err }]
        }
      }));
      return;
    }
  }
  
  if (Number(params.sendInBackground) === 1 || params.sendInBackground === true) {
    if (Number(params.modal) === 1 || params.modal === true) {
      yield put(toggleLoadingBackdrop(true, params.modalMessage || "Traitement d'une commande en cours"));
    }
  }
  
  if (params.attachments && params.attachments.length > 0) {
    for (let i = 0; i < params.attachments.length; i += 1) {
      const att            = params.attachments[i];
      const formatsMatched = yield call(checkFormatAndBase64Match, att.documentFormat, att.fileContentInBase64);
      if (!formatsMatched) {
        yield call(
          handleError,
          requestId,
          responseChannel,
          channelUrl,
          type,
          {
            i_apiErrorType                : errorTypes.RemoteErrors,
            i_apiErrorCode                : "INVALID_FORMAT",
            s_apiErrorExtendedInformations: `Le contenu du document "${att.documentTitle}" ne correspond pas au format de document fourni.`
          }
        );
        yield call(updateToast, requestId, toast.TYPE.ERROR);
        return;
      }
    }
  }
  
  yield put(clearSection(apiSections.MSS_SEND_SMTP_EMAIL));
  
  if (Number(params.sendInBackground) === 1 || params.sendInBackground === true) {
    const {
            apiType,
            esUser,
            hpAuthenticationMode,
            forceSchematronsValidation,
            ignorePdfA1Transparency,
            disabledPdfA1Conversion,
            disableIheXdmPdfTitlePage,
            disableIheXdmPdfDataMatrixBlock
          } = yield select(getMssSendEmailParams);
    
    const action = getSendMssEmailAction(
      mssApiType,
      apiType,
      {
        sender                 : mssEmailConfig,
        title                  : params.title,
        messageContent         : params.messageContent,
        recipients             : params.recipients,
        cc                     : params.cc,
        bcc                    : params.bcc,
        attachments            : params.attachments,
        otherAttachments       : params.otherAttachments,
        isHtml                 : true,
        sendReceiptNotification: !!params.notificationReceiver,
        notificationReceivers  : params.notificationReceiver,
        receiptNotificationType: params.notificationReceiversType,
        replyTo                : params.replyTo || mssReplyTo,
        inReplyToMessageIds    : params.inReplyToMessageIds,
        references             : params.references,
        senderWording          : params.senderWording || mssSenderWording,
        messageId              : params.messageId || generateMessageId(),
        
        forceSchematronsValidation,
        ignorePdfA1Transparency: params.ignorePdfA1Transparency !== undefined ? params.ignorePdfA1Transparency : ignorePdfA1Transparency,
        disabledPdfA1Conversion: params.disabledPdfA1Conversion !== undefined ? params.disabledPdfA1Conversion : disabledPdfA1Conversion,
        
        disableIheXdmPdfTitlePage      : params.disableIheXdmPdfTitlePage || disableIheXdmPdfTitlePage,
        disableIheXdmPdfDataMatrixBlock: params.disableIheXdmPdfDataMatrixBlock || disableIheXdmPdfDataMatrixBlock,
        getDocumentContent             : params.getDocumentContent,
        endConversation                : params.forbidRecipientAnswer || params.endConversation,
        
        Identity                    : params.insiIdentity,
        insIsNotQualified           : params.insIsNotQualified,
        AdditionalPatientIdentifiers: params.AdditionalPatientIdentifiers
      },
      esUser,
      hpAuthenticationMode
    );
    
    yield put(action);
  } else {
    yield put(resetMssEmailContent(params.attachments.length > 0));
    yield put(setMssEmailContent({ ...params, isRemote: true, mssEmailConfig }));
    yield put(setShowMssPopup(true));
    if (responseChannel !== remoteResponseChannels.CONNECTOR) {
      response = {
        "@RelatesTo": requestId,
        "@status"   : "urn:ihe:iti:2007:ResponseStatusType:PartialSuccess"
      };
      
      yield call(updateToast, requestId, toast.TYPE.SUCCESS);
      yield call(sendResponse, response, responseChannel, channelUrl, type);
    }
  }
  
  const sendResult = yield take([
    dmpconnectRemoteActionConstants.DMPC_REMOTE_MSS_SEND_MESSAGE_REFUSED,
    dmpCommandSuccessContextualizedType(apiSections.MSS_IMAP_APPEND_MESSAGE),
    dmpCommandFailureContextualizedType(apiSections.MSS_SEND_SMTP_EMAIL),
    dmpCommandFailureContextualizedType(apiSections.MSS_IMAP_APPEND_MESSAGE)
  ]);
  
  if (sendResult && sendResult.type === dmpconnectRemoteActionConstants.DMPC_REMOTE_MSS_SEND_MESSAGE_REFUSED) {
    response = generateRemoteFailureResponse(requestId, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "REJECTED_BY_USER",
      s_apiErrorExtendedInformations: "L’utilisateur a rejeté l’action demandée."
    });
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  } else if (
    // Si le message a bien été envoyé, on demande la copie
    // quelque soit le résultat de la copie, la commande est un succès
    sendResult &&
    [
      dmpCommandSuccessContextualizedType(apiSections.MSS_IMAP_APPEND_MESSAGE),
      dmpCommandFailureContextualizedType(apiSections.MSS_IMAP_APPEND_MESSAGE)
    ].includes(sendResult.type)
  ) {
    response = {
      "@RelatesTo": requestId,
      "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
    };
    
    const
      {
        data: {
          UniqueIds,
          DocumentsContent
        } = {},
        
        context: {
          dataExtra: {
            UniqueIds       : extraUniqueIds,
            DocumentsContent: extraDocumentContents
          } = {}
        } = {}
      } = sendResult;
    
    const uniqueIds           = UniqueIds || extraUniqueIds;
    const documentsCdaContent = DocumentsContent || extraDocumentContents;
    
    if (uniqueIds && uniqueIds.length > 0) {
      response.uniqueIDs = uniqueIds.join(";");
    }
    if (documentsCdaContent && documentsCdaContent.length > 0) {
      response.documentsCdaContent = rename(documentsCdaContent, key => key.replace(/^s_|^i_/, ""));
    }
    
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  } else {
    const { data: error } = sendResult;
    
    response = generateRemoteFailureResponse(requestId, error);
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  
  yield put(clearSection(apiSections.MSS_SEND_SMTP_EMAIL));
  yield put(toggleLoadingBackdrop(false, ""));
  yield put(setShowMssPopup(false));
  yield put(resetMssEmailContent(false));
  yield call(sendResponse, response, responseChannel, channelUrl, type);
}

function * handleGetMssHpInfos (requestId, request, responseChannel, channelUrl, type) {
  const params = type === remoteFormats.JSON
    ? extractJSONGetMssInfosParams(request)
    : extractGetMssInfosParams(request);
  
  yield put(getAction(
    commands.getMssHpInfos,
    apiSections.MSS_GET_HP_INFOS,
    {
      ...formatGetMssHpInfosParams(params.name, params.given, params.rpps, params.specialty, params.organization),
      ...formatQuery(params)
    },
    {
      remote    : true,
      subSection: `remote-${requestId}`
    }
  ));
  
  let result;
  
  while (result === undefined) {
    const commandResult = yield take([
      dmpRemoteCommandSuccessContextualizedType(apiSections.MSS_GET_HP_INFOS),
      dmpRemoteCommandFailureContextualizedType(apiSections.MSS_GET_HP_INFOS)
    ]);
    
    const { context: { subSection } } = commandResult;
    if (subSection === `remote-${requestId}`) {
      result = commandResult;
    }
  }
  
  const {
          data   : {
            PSList,
            i_queryLimitHappened,
            status,
            ...error
          }, type: resultType
        } = result;
  
  let response;
  
  if (resultType === dmpRemoteCommandSuccessContextualizedType(apiSections.MSS_GET_HP_INFOS)) {
    response = {
      "@RelatesTo"      : requestId,
      "@status"         : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success",
      results           : rename(PSList, key => key.replace(/^s_/, "")),
      queryLimitHappened: i_queryLimitHappened
    };
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  } else {
    response = generateRemoteFailureResponse(requestId, error);
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  }
  yield call(sendResponse, response, responseChannel, channelUrl, type);
}

function * handleLogout (requestId, responseChannel, channelUrl, type) {
  const response = {
    "@RelatesTo": requestId,
    "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
  };
  yield call(sendResponse, response, responseChannel, channelUrl, type);
  
  yield put(logout("/logout"));
}

function * handleConnectorRemoteOutExport (notification, notificationId) {
  const sessionId = yield select(getSessionId);
  
  console.log("outgoingMessage_connector", notification);
  yield put({
    type   : dmpconnectRemoteActionConstants.DMPC_REMOTE_SEND_COMMAND,
    command: {
      s_commandName: "hl_sendRemoteOutMessage",
      s_sessionId  : sessionId,
      Message      : notification
    },
    context: {
      section   : "sendRemoteOutMessage",
      subSection: notificationId
    }
  });
  let success;
  
  while (success === undefined) {
    const result                            = yield take([
      dmpRemoteCommandSuccessContextualizedType("sendRemoteOutMessage"),
      dmpRemoteCommandFailureContextualizedType("sendRemoteOutMessage")
    ]);
    const { context: { subSection }, type } = result;
    if (subSection === notificationId) {
      success = type === dmpRemoteCommandSuccessContextualizedType("sendRemoteOutMessage");
    }
  }
  return success;
}

function * handleEmailConnectorRemoteOutExport (notification, messageId, action) {
  const exportResult = yield call(handleConnectorRemoteOutExport, notification, messageId);
  
  yield put(remoteExportEmailDone(action.email));
  const id = generateUniqueId();
  toast(
    exportResult
      ? "Email exporté avec succès"
      : "Erreur pendant l'export de l'email",
    {
      toastId        : id,
      type           : exportResult ? "success" : "error",
      position       : "top-right",
      closeOnClick   : true,
      autoClose      : 2000,
      hideProgressBar: true
    }
  );
  if (exportResult) {
    setTimeout(() => toast.dismiss(id), 2000);
  }
}

const getRemoteFormat = (state) => {
  const {
          dmpConnectPersistedAppConfiguration: {
            remoteFormat = remoteFormats.XML
          }
        } = state;
  return remoteFormat;
};

const getDocument = function * (ins, uniqueUUid) {
  let document             = yield select(getDocumentFromUniqueId, uniqueUUid);
  const { uniqueId, uuid } = explodeUniqueUUid(uniqueUUid);
  
  if (!document) {
    yield call(sendActionAndWaitResult, {
      func      : getAction(
        commands.getDocumentContentByUniqueId,
        apiSections.DOCUMENT_CONTENT_SECTION,
        {
          ...formatGetDocumentContentByUniqueIdParams(ins, uniqueId, uuid),
          i_getCdaContent: 1
        },
        {
          subSection: uniqueUUid
        }
      ),
      section   : apiSections.DOCUMENT_CONTENT_SECTION,
      subSection: uniqueUUid
    });
    document = yield select(getDocumentFromUniqueId, uniqueUUid);
  }
  let documentInfos = yield select(getDocumentInfoFromCache, ins, uniqueUUid);
  return { ...document, ...documentInfos };
};

const formatDocument = (document) => {
  const cdaHeaders = getCdaHeaders(document);
  const cdaContent = getCdaContent(document);
  const content    = getDocumentData(document);
  const author     = document.Authors && document.Authors.length > 0 ? document.Authors[0] : {};
  
  return {
    uniqueId: document.s_uniqueId,
    uuid: document.s_uuid,
    content,
    htmlCdaHeaders: cdaHeaders,
    cdaContent,
    format: (
      documentFormatNames[
        document.i_document_Format || document.i_documentFormat
      ] ||
      document.s_documentFormatCode ||
      ""
    ).toLowerCase(),
    typeCode: document.s_typeCode,
    title: document.s_title,
    description: document.s_description,
    invisiblePatient: isHiddenFor(
      document.i_document_Visibility || document.i_documentVisibility,
      documentVisibilityStatuses.PATIENT_HIDDEN
    )
      ? 1
      : 0,
    masquePs: isHiddenFor(
      document.i_document_Visibility || document.i_documentVisibility,
      documentVisibilityStatuses.HEALTCARE_PROFESSIONAL_HIDDEN
    )
      ? 1
      : 0,
    creationTime: document.s_creationDate,
    author: {
      "@name": author.s_hpName || "",
      "@given": author.s_hpGiven || "",
      "@institution": author.s_hpInstitution || "",
      "@profession": author.s_hpProfession || "",
    },
  };
};

export const handleExportDocumentMultiple = function * ({ ins, uniqueUUids }) {

  postMessageToIframeParent({
    type: "export_documents_start",
    desc: "Some documents are being exported.",
  });

  const documents = yield all(uniqueUUids.map(uniqueUUid => call(getDocument, ins, uniqueUUid)));
  
  const { insExtension, insRoot } = ins.match(/^(?<insExtension>\w{15})(?<insRoot>[a-zA-Z]*)$/).groups;
  
  const notificationId = generateUniqueId().toUpperCase();
  const notification   = {
    notification: {
      "@data"  : "DMPDocuments",
      "@id"    : `{${notificationId}}`,
      patient  : {
        ins: {
          "@extension": insExtension,
          "@root"     : insRoot || "N"
        }
      },
      documents: documents.filter(document => !!document).map(document => formatDocument(document))
    }
  };
  
  const exportChannel    = yield select(getRemoteExportChannel);
  const exportChannelUrl = yield select(getRemoteExportChannelUrl);
  const remoteFormat     = yield select(getRemoteFormat);
  
  if (exportChannel === remoteResponseChannels.CONNECTOR) {
    const exportResult = yield call(handleConnectorRemoteOutExport, notification, notificationId);
    const id           = generateUniqueId();
    toast(
      exportResult
        ? "Documents exportés avec succès"
        : "Erreur pendant l'export des documents",
      {
        toastId        : id,
        type           : exportResult ? "success" : "error",
        position       : "top-right",
        closeOnClick   : true,
        autoClose      : 2000,
        hideProgressBar: true
      }
    );
    if (exportResult) {
      setTimeout(() => toast.dismiss(id), 2000);
    }
  } else {
    sendToOtherChannel(notification, exportChannel, exportChannelUrl, true, "Documents exportés avec succès", remoteFormat);
  }
  
};

export const handleExportDocument = function * (action) {
  const { uniqueUUid, ins }                   = action;
  const { previousUniqueId, currentUniqueId } = yield select((state) => {
    const {
            dmpconnectRemote: {
              exportDocUniqueIds = {}
            }
          } = state;
    
    return exportDocUniqueIds;
  });

  postMessageToIframeParent({
    type: "export_document_start",
    desc: "A document is being exported.",
  });


  const document = yield call(getDocument, ins, uniqueUUid);
  
  const { insExtension, insRoot } = ins.match(/^(?<insExtension>\w{15})(?<insRoot>[a-zA-Z]*)$/).groups;
  
  const notificationId = generateUniqueId().toUpperCase();
  const notification   = {
    notification: {
      "@data"         : "DMPDocument",
      "@id"           : `{${notificationId}}`,
      patient         : {
        ins: {
          "@extension": insExtension,
          "@root"     : insRoot || "N"
        }
      },
      previousUniqueId: previousUniqueId && currentUniqueId === document.s_uniqueId ? previousUniqueId : undefined,
      document        : formatDocument(document)
    }
  };
  
  const exportChannel    = yield select(getRemoteExportChannel);
  const exportChannelUrl = yield select(getRemoteExportChannelUrl);
  const remoteFormat     = yield select(getRemoteFormat);
  
  yield put(remoteSetExportUniqueIds({ previousUniqueId: undefined, currentUniqueId: undefined }));
  
  if (exportChannel === remoteResponseChannels.CONNECTOR) {
    const exportResult = yield call(handleConnectorRemoteOutExport, notification, notificationId);
    const id           = generateUniqueId();
    toast(
      exportResult
        ? "Document exporté avec succès"
        : "Erreur pendant l'export du document",
      {
        toastId        : id,
        type           : exportResult ? "success" : "error",
        position       : "top-right",
        closeOnClick   : true,
        autoClose      : 2000,
        hideProgressBar: true
      }
    );
    if (exportResult) {
      setTimeout(() => toast.dismiss(id), 2000);
    }
  } else {
    sendToOtherChannel(notification, exportChannel, exportChannelUrl, true, "Document exporté avec succès", remoteFormat);
  }
};

const getIheXdmDetailsAndFormatAttachments = function * (attachments) {
  const formattedAttachments = [];
  
  for (let i = 0; i < attachments.length; i += 1) {
    const attachment = attachments[i];
    const {
            contentType, fileName, size, content
          }          = attachment;
    
    let iheXdmDetails;
    if (contentType.indexOf("application/zip") !== -1) {
      yield put(getAction(
        commands.getDocumentsFromIheXdm,
        apiSections.GET_DOCS_FROM_IHE_XDM,
        content,
        {
          subSection : fileName,
          silentError: true
        }
      ));
      
      const iheXdmResults = yield take([
        dmpCommandSuccessContextualizedType(apiSections.GET_DOCS_FROM_IHE_XDM),
        dmpCommandFailureContextualizedType(apiSections.GET_DOCS_FROM_IHE_XDM)
      ]);
      if (iheXdmResults && iheXdmResults.type === dmpCommandSuccessContextualizedType(apiSections.GET_DOCS_FROM_IHE_XDM)) {
        const { data: { Documents = [] } = {} } = iheXdmResults;
        const processedDocuments                = Documents.map((doc) => {
          const { s_cdaContentInBase64 } = doc;
          const xml                      = b64DecodeUnicode(s_cdaContentInBase64);
          const {
                  ClinicalDocument: {
                    relatedDocument: {
                      _attributes   : { typeCode } = {},
                      parentDocument: {
                        id: {
                          _attributes: {
                            root: replacedDocumentId
                          } = {}
                        } = {}
                      }                            = {}
                    } = {}
                  } = {}
                }                        = xml2js(xml, { compact: true });
          
          if (typeCode === "RPLC") {
            return { ...doc, replacedDocumentUniqueId: replacedDocumentId };
          }
          
          return doc;
        });
        // supprimer les préfixes s_ et _i des clés
        iheXdmDetails                           = rename(processedDocuments, key => key.replace(/^s_|^i_/, ""));
      }
    }
    
    formattedAttachments.push({
      contentType,
      fileName,
      size     : String(size),
      content,
      documents: iheXdmDetails
    });
  }
  
  return formattedAttachments;
};

export const handleExportEmail = function * (action) {
  const {
          email: {
            mssEmail,
            attachments,
            fragment,
            body,
            messageId,
            headerMessageId,
            inReplyToMessageIds,
            references,
            replyTo,
            remoteExporting,
            date,
            flags,
            folderId,
            from,
            ...rest
          }
        } = action;

  postMessageToIframeParent({
    type: "export_email_start",
    desc: "A MSS message is being exported.",
  });


  try {
    const results = yield call(handleDownloadAllAttachments, attachments, messageId, mssEmail);
    
    const formattedAttachments = yield call(getIheXdmDetailsAndFormatAttachments, results);
    const notification         = {
      notification: {
        "@data": "email",
        "@id"  : `{${generateUniqueId().toUpperCase()}}`,
        email  : {
          ...rest,
          ...Object.entries(flags).reduce((result, [key, value]) => ({ ...result, [`@${key}`]: String(value) }), {}),
          from    : from[0],
          replyTo,
          folderId: String(folderId),
          date    : String(date),
          // attachments: results.map((att) => {
          //   const {
          //     contentType, fileName, size, attachementB64,
          //   } = att;
          //   return {
          //     contentType,
          //     fileName,
          //     size: String(size),
          //     content: attachementB64,
          //   };
          // }),
          attachments        : formattedAttachments,
          fragment           : fragment ? b64EncodeUnicode(fragment) : undefined,
          body               : b64EncodeUnicode(body),
          messageId          : headerMessageId || messageId,
          inReplyToMessageIds: inReplyToMessageIds ? inReplyToMessageIds.join(";") : undefined,
          references         : references ? references.join(";") : undefined
        }
      }
    };
    
    const exportChannel    = yield select(getRemoteExportChannel);
    const exportChannelUrl = yield select(getRemoteExportChannelUrl);
    const remoteFormat     = yield select(getRemoteFormat);
    
    if (exportChannel === remoteResponseChannels.CONNECTOR) {
      yield call(handleEmailConnectorRemoteOutExport, notification, messageId, action);
    } else {
      sendToOtherChannel(notification, exportChannel, exportChannelUrl, true, "Email exporté avec succès", remoteFormat);
      yield put(remoteExportEmailDone(action.email));
    }
  } catch (e) {
    yield put(remoteExportEmailDone(action.email));
  }
};

export const handleExportVitaleData = function * (action) {
  const remoteControlActive         = yield select(isRemoteControlActive);
  const remoteExportChannel         = yield select(getRemoteExportChannel);
  const remoteExportChannelUrl      = yield select(getRemoteExportChannelUrl);
  const remoteExportVitaleData      = yield select(getRemoteExportVitaleData);
  const remoteControlDisableExports = yield select(getRemoteDisableExports);
  const remoteFormat                = yield select(getRemoteFormat);
  
  if (
    !remoteControlDisableExports
    && (
      remoteControlActive
      || [remoteResponseChannels.IFRAME, remoteResponseChannels.URL].includes(remoteExportChannel)
    )
    && remoteExportVitaleData
  ) {
    const { type, data: { s_status, ...data } } = action;
    const dataType                              = type === dmpCommandSuccessContextualizedType(apiSections.GET_APCV_CONTEXT)
      ? "ApCV"
      : "vitaleCard";
    const notification                          = {
      notification: {
        "@data"   : dataType,
        "@id"     : `{${generateUniqueId().toUpperCase()}}`,
        [dataType]: data
      }
    };
    
    if (remoteExportChannel === remoteResponseChannels.CONNECTOR) {
      const sessionId = yield select(getSessionId);
      console.log("outgoingMessage_connector", notification);
      yield put({
        type   : dmpconnectRemoteActionConstants.DMPC_REMOTE_SEND_COMMAND,
        command: {
          s_commandName: "hl_sendRemoteOutMessage",
          s_sessionId  : sessionId,
          Message      : notification
        },
        context: {
          section   : "sendRemoteOutMessage",
          subSection: dataType
        }
      });
    } else {
      sendToOtherChannel(notification, remoteExportChannel, remoteExportChannelUrl, false, "", remoteFormat);
    }
  }
};

export const handleExportVitaleCardData = function * (action, vitaleXml) {
  // const vitaleXml = yield call(getVitaleCardXmlContent);
  if (vitaleXml) {
    yield call(handleExportVitaleData, {
      ...action,
      data: {
        ...action.data,
        rawData: vitaleXml
      }
    });
  }
};

export const handleExportCpxData = function * (cards) {
  const remoteControlActive         = yield select(isRemoteControlActive);
  const remoteExportChannel         = yield select(getRemoteExportChannel);
  const remoteExportChannelUrl      = yield select(getRemoteExportChannelUrl);
  const remoteControlDisableExports = yield select(getRemoteDisableExports);
  const remoteFormat                = yield select(getRemoteFormat);
  
  if (
    !remoteControlDisableExports
    && (
      remoteControlActive
      || [remoteResponseChannels.IFRAME, remoteResponseChannels.URL].includes(remoteExportChannel)
    )
    && Number(env.REACT_APP_REMOTE_CONTROL_AUTO_EXPORT_CPX_DATA) === 1
  ) {
    const notification = {
      notification: {
        "@data": "CPX",
        "@id"  : `{${generateUniqueId().toUpperCase()}}`,
        cards
      }
    };
    
    if (remoteExportChannel === remoteResponseChannels.CONNECTOR) {
      const sessionId = yield select(getSessionId);
      console.log("outgoingMessage_connector", notification);
      yield put({
        type   : dmpconnectRemoteActionConstants.DMPC_REMOTE_SEND_COMMAND,
        command: {
          s_commandName: "hl_sendRemoteOutMessage",
          s_sessionId  : sessionId,
          Message      : notification
        },
        context: {
          section   : "sendRemoteOutMessage",
          subSection: "cpx"
        }
      });
    } else {
      sendToOtherChannel(notification, remoteExportChannel, remoteExportChannelUrl, false, "", remoteFormat);
    }
  }
};

function * handleCpxPinCode (requestId, requestRest, responseChannel, channelUrl, type) {
  let pincode;
  if (type === remoteFormats.JSON) {
    const {
            pinCode
            // practiceLocation,
          } = requestRest;
    pincode = pinCode;
  } else {
    const {
            pinCode: { value: pinCodeXml } = {}
            // practiceLocation,
          } = requestRest;
    pincode = pinCodeXml;
  }
  
  // if (practiceLocation) {
  //   const {
  //     rpps,
  //     cpxPracticeLocationIndice = undefined,
  //     practiceSetting,
  //     healthcareSetting,
  //     billingNumber,
  //     customPracticeLocation: {
  //       structureName,
  //       structureId,
  //       structureIdType,
  //       activitySector,
  //     } = {},
  //   } = practiceLocation;
  //
  //   const cpxInfos = Object.values(cpxHpInfos).find(info => info.s_idNatPs === rpps);
  //
  //   if (cpxInfos) {
  //     let cpxConfig = {
  //       practiceSetting,
  //       healthcareSetting,
  //       billingNumber,
  //       codeSpeAMO: '99', // Non définie (99) par défaut
  //       fromRemote: true,
  //       forcedCustomPracticeLocation: false,
  //     };
  //
  //     if (Number(cpxPracticeLocationIndice) >= 0) {
  //       cpxConfig = {
  //         ...cpxConfig,
  //         customPracticeLocationStructureName: null,
  //         customPracticeLocationStructureIdType: null,
  //         customPracticeLocationStructureId: null,
  //         customPracticeLocationActivitySector: null,
  //         practiceLocationSetting: Number(cpxPracticeLocationIndice),
  //       };
  //     } else {
  //       cpxConfig = {
  //         ...cpxConfig,
  //         customPracticeLocationStructureName: structureName,
  //         customPracticeLocationStructureIdType: structureIdType,
  //         customPracticeLocationStructureId: structureId,
  //         customPracticeLocationActivitySector: activitySector,
  //         practiceLocationSetting: null,
  //       };
  //     }
  //
  //     yield put(setUserConfiguration(cpxInfos.s_idNatPs, cpxConfig));
  //   } else {
  //     postMessageToIframeParent({
  //       type: 'practice_location_error',
  //       error: 'no card matches the given rpps',
  //     });
  //     throw new Error();
  //   }
  // }
  
  yield put(setPinCode(null));
  yield put(setPinCode(encodeIns(pincode)));
  yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  yield call(sendResponse, {
    "@RelatesTo": requestId,
    "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
  }, responseChannel, channelUrl);
}

function * handlePscAccessToken (requestId, requestRest, responseChannel, channelUrl, type, isLoggedIn) {
  let token;
  if (type === remoteFormats.JSON) {
    const {
            accessToken
          } = requestRest;
    token   = accessToken;
  } else {
    const {
            accessToken: { value: accessTokenXml } = {}
          } = requestRest;
    token   = accessTokenXml;
  }
  
  // verify token
  const { err } = yield call(verifyJwtPromise, token);
  yield put(setMssConfiguration("mssPscAccessToken", ""));
  yield put(setUserJWT(undefined));
  
  let response;
  
  if (err) {
    const {
            name,
            ...rest
          }  = err;
    response = {
      "@RelatesTo": requestId,
      "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Failure",
      errors      : [
        {
          "@code": err.name,
          details: [{ ...rest }]
        }
      ]
    };
    yield call(updateToast, requestId, toast.TYPE.ERROR);
  } else {
    yield put(setMssConfiguration("mssPscAccessToken", token));
    yield put(setUserJWT({ access_token: token }));
    if (isLoggedIn) {
      const apiType = yield select(getApiType);
      if (apiType !== API_TYPES.REST) {
        yield put(getAction(
          commands.updateCpxAuthenticationToken,
          "updateCpxAuthenticationToken",
          {
            s_authenticationToken: token
          }
        ));
      }
    }
    response = {
      "@RelatesTo": requestId,
      "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
    };
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  }
  yield call(sendResponse, response, responseChannel, channelUrl, type);
}

function * handleSetMssPatientInfos (requestId, requestRest, responseChannel, channelUrl, type) {
  try {
    let patients;
    if (type === remoteFormats.JSON) {
      const {
              patients: commandJSONPatients
            }  = requestRest;
      patients = commandJSONPatients;
    } else {
      const {
              patients: {
                patient: commandXMLPatients
              } = {}
            }           = requestRest;
      const tmpPatients = commandXMLPatients && !Array.isArray(commandXMLPatients) ? [commandXMLPatients] : commandXMLPatients;
      
      patients = tmpPatients.map(p => ({
        name : p.name.value,
        given: p.given.value,
        ins  : p.ins.value
      }));
    }
    
    yield all(patients.map(p => put(setMssPatientInfos(p))));
    
    const response = {
      "@RelatesTo": requestId,
      "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
    };
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
    yield call(sendResponse, response, responseChannel, channelUrl, type);
  } catch (e) {
    const error = {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "UNEXPECTED_ERROR",
      s_apiErrorExtendedInformations: e.message
    };
    yield call(handleError, requestId, responseChannel, channelUrl, type, error);
  }
}

const getMssClientMode = ({ dmpConnectPersistedAppConfiguration: { mssClientMode } = {} }) => mssClientMode;

function * getDocumentStatus (ins, uniqueId) {
  // récupérer le document
  const findDocumentByUniqueIdResult = yield call(sendActionAndWaitResult, {
    func      : getAction(
      commands.findDocumentsByUniqueId,
      apiSections.FIND_DOCUMENT_UNIQUEID_SECTION,
      formatFindDocumentsByUniqueId(ins, [uniqueId]),
      { silentError: true, subSection: uniqueId, noRetries: true, synchronous: true }
    ),
    section   : apiSections.FIND_DOCUMENT_UNIQUEID_SECTION,
    subSection: uniqueId
  });
  
  // si erreur, modifié ou supprimé
  if (!isReady(findDocumentByUniqueIdResult.data)) {
    
    // récupérer l'historique
    const historyResult = yield call(sendActionAndWaitResult, {
      func      : getAction(
        commands.getDocumentHistoryByUniqueId,
        apiSections.GET_DOCUMENT_HISTORY_SECTION,
        formatGetDocumentHistoryByUniqueId(ins, uniqueId),
        { silentError: true, subSection: uniqueId }
      ),
      section   : apiSections.GET_DOCUMENT_HISTORY_SECTION,
      subSection: uniqueId
    });
    
    // si erreur, supprimé
    if (!isReady(historyResult.data)) {
      yield put(removeDocFromPersistantData(uniqueId, undefined, ins));
      yield put(removeDocumentFromCache(uniqueId, ins));
      return { uniqueId, status: "not-found" };
    }
    // sinon, modifié, récupéré l'uniqueId actif
    else {
      const { Documents = [] } = historyResult.data;
      const activeDoc          = Documents.find(doc => (doc.i_document_Status === documentStatuses.APPROVED));
      if (activeDoc) {
        return { uniqueId, status: "modified", newUniqueId: activeDoc.s_uniqueId };
      } else {
        yield put(removeDocFromPersistantData(uniqueId, undefined, ins));
        yield put(removeDocumentFromCache(uniqueId, ins));
        return { uniqueId, status: "not-found" };
      }
    }
  }
  
  return { uniqueId, status: "exists" };
}

function * handleGetDocumentsStatus (requestId, confidentialityLevel, requestRest, responseChannel, channelUrl, type) {
  const { accessRights, accessRights: { psId, esId, authenticationType, airOnly } = {} } = yield select(getAccessRights);
  if (!isTransactionAllowed(accessRights, transactions.FIND_DOCUMENTS_META) === true) {
    yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const secretConnection = yield select(getSecretConnection);
  
  const {
    ins,
          uniqueIds,
          addAccessAuthorization,
          useBdgAccess,
          bdgAccessReason
  } = type === remoteFormats.JSON
    ? extractJSONGetDocumentsStatusParams(requestRest)
    : extractGetDocumentsStatusParams(requestRest);

  if (confidentialityLevel !== -1) {
    yield call(handleSetConfidentialityLevel, {
      ins,
      confidentialityLevel
    });
    const confidentialityLevelResult = yield take([
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
    ]);

    if (
      confidentialityLevelResult
      && confidentialityLevelResult.type === dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
    ) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
      return;
    }
  }
  
  const isAuthorized = yield call(isDmpAuthorized, ins, requestId, responseChannel, channelUrl, type, addAccessAuthorization, true);
  if (!isAuthorized) {
    
    if (addAccessAuthorization) {
      const ok = yield call(handleAddAuthorization, ins, psId, airOnly, authenticationType, esId, requestId, responseChannel, channelUrl, type);
      if (!ok) {
        yield call(handleSetConfidentialityLevel, {
          ins,
          secretConnection
        });
        return;
      }
    } else if (useBdgAccess && bdgAccessReason) {
      yield call(handleSetDmpAccessMode, { accessMode: accessModes.BrisDeGlace, accessModeReason: bdgAccessReason });
      const accessModeResult = yield take([
        dmpCommandSuccessContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION),
        dmpCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)
      ]);
      if (accessModeResult && accessModeResult.type === dmpRemoteCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)) {
        yield call(
          handleError,
          requestId,
          responseChannel,
          channelUrl,
          type,
          accessModeResult.data
        );
        yield call(updateToast, requestId, toast.TYPE.ERROR);
        return;
      }
    } else {
      yield call(handleSetConfidentialityLevel, {
        ins                 : "all",
        confidentialityLevel: Number(secretConnection)
      });
      yield call(handleSetDmpAccessMode, { accessMode: accessModes.NormalAccess, accessModeReason: "" });
      return;
    }
  }
  
  const statuses = yield all(uniqueIds.map(uniqueId => call(getDocumentStatus, ins, uniqueId)));
  
  yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  yield call(
    sendResponse,
    { statuses },
    responseChannel,
    channelUrl,
    type
  );
  
  yield call(handleSetConfidentialityLevel, {
    ins                 : "all",
    confidentialityLevel: Number(secretConnection)
  });
  yield call(handleSetDmpAccessMode, { accessMode: accessModes.NormalAccess, accessModeReason: "" });
}

function * handleOpenDocument (requestId, confidentialityLevel, requestRest, responseChannel, channelUrl, type) {
  const { accessRights, accessRights: { psId, esId, authenticationType, airOnly } = {} } = yield select(getAccessRights);
  if (!isTransactionAllowed(accessRights, transactions.FIND_DOCUMENTS_META) === true) {
    yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const secretConnection = yield select(getSecretConnection);
  
  const {
    ins,
          uniqueId,
          openLastVersion,
          addAccessAuthorization,
          useBdgAccess,
          bdgAccessReason
  } = type === remoteFormats.JSON
    ? extractJSONOpenDocumentParams(requestRest)
    : extractOpenDocumentParams(requestRest);

  if (confidentialityLevel !== -1) {
    yield call(handleSetConfidentialityLevel, {
      ins,
      confidentialityLevel
    });
    const confidentialityLevelResult = yield take([
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
    ]);

    if (
      confidentialityLevelResult
      && confidentialityLevelResult.type === dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
    ) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
      return;
    }
  }
  
  const isAuthorized = yield call(isDmpAuthorized, ins, requestId, responseChannel, channelUrl, type, addAccessAuthorization, true);
  if (!isAuthorized) {
    
    if (addAccessAuthorization) {
      const ok = yield call(handleAddAuthorization, ins, psId, airOnly, authenticationType, esId, requestId, responseChannel, channelUrl, type);
      if (!ok) {
        yield call(handleSetConfidentialityLevel, {
          ins,
          secretConnection
        });
        return;
      }
    } else if (useBdgAccess && bdgAccessReason) {
      yield call(handleSetDmpAccessMode, { accessMode: accessModes.BrisDeGlace, accessModeReason: bdgAccessReason });
      const accessModeResult = yield take([
        dmpCommandSuccessContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION),
        dmpCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)
      ]);
      if (accessModeResult && accessModeResult.type === dmpRemoteCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)) {
        yield call(
          handleError,
          requestId,
          responseChannel,
          channelUrl,
          type,
          accessModeResult.data
        );
        yield call(updateToast, requestId, toast.TYPE.ERROR);
        return;
      }
    } else {
      yield call(handleSetConfidentialityLevel, {
        ins                 : "all",
        confidentialityLevel: Number(secretConnection)
      });
      return;
    }
  }
  
  const documentStatus          = yield call(getDocumentStatus, ins, uniqueId);
  const { status, newUniqueId } = documentStatus;
  
  let document;
  if (status === "exists") {
    let { Documents = [] } = yield select((state) => {
      const {
              dmpconnect: {
                [apiSections.FIND_DOCUMENT_UNIQUEID_SECTION]: {
                  [uniqueId]: document
                }
              }
            } = state;
      return document;
    });
    document               = Documents[0];
  } else if (status === "modified" && openLastVersion === true) {
    
    const findDocumentByUniqueIdResult = yield call(sendActionAndWaitResult, {
      func      : getAction(
        commands.findDocumentsByUniqueId,
        apiSections.FIND_DOCUMENT_UNIQUEID_SECTION,
        formatFindDocumentsByUniqueId(ins, [newUniqueId]),
        { silentError: true, subSection: newUniqueId, noRetries: true }
      ),
      section   : apiSections.FIND_DOCUMENT_UNIQUEID_SECTION,
      subSection: newUniqueId
    });
    
    const {
            data: {
              Documents = []
            }
          }  = findDocumentByUniqueIdResult;
    document = Documents[0];
  }
  
  if (document) {
    if (canConsultDocument(document, accessRights)) {
      
      yield put(remoteSetExportUniqueIds({ currentUniqueId: document.s_uniqueId, previousUniqueId: uniqueId }));
      
      yield put(push(`/dmp/${encodeIns(ins)}/document/${encodeIns(getUniqueUUid(document.s_uniqueId, document.s_uuid))}`));
      yield call(
        sendResponse,
        {
          "@RelatesTo": requestId,
          "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success"
        },
        responseChannel,
        channelUrl,
        type
      );
      yield call(updateToast, requestId, toast.TYPE.SUCCESS);
      
    } else {
      yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type, "Vous n'êtes pas autorisé à consulter ce document.");
      
    }
  } else {
    const response = generateRemoteFailureResponse(requestId, {
      i_apiErrorType                : errorTypes.RemoteErrors,
      i_apiErrorCode                : "DOCUMENT_NOT_FOUND",
      s_apiErrorExtendedInformations: "Document non trouvé"
    });
    yield call(
      sendResponse,
      response,
      responseChannel,
      channelUrl,
      type
    );
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  }
  
  yield call(handleSetConfidentialityLevel, {
    ins                 : "all",
    confidentialityLevel: Number(secretConnection)
  });
  yield call(handleSetDmpAccessMode, { accessMode: accessModes.NormalAccess, accessModeReason: "" });
}

function * handleFindDocuments (requestId, confidentialityLevel, requestRest, responseChannel, channelUrl, type) {
  const { accessRights, accessRights: { psId, esId, authenticationType, airOnly } = {} } = yield select(getAccessRights);
  if (!isTransactionAllowed(accessRights, transactions.FIND_DOCUMENTS_META) === true) {
    yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
    return;
  }
  
  const secretConnection = yield select(getSecretConnection);
  
  const params = type === remoteFormats.JSON
    ? extractFindDocumentsJSONParams(requestRest)
    : extractFindDocumentsParams(requestRest);

  if (confidentialityLevel !== -1) {
    yield call(handleSetConfidentialityLevel, {
      ins: params.ins,
      confidentialityLevel
    });
    const confidentialityLevelResult = yield take([
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
      dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
    ]);

    if (
      confidentialityLevelResult
      && confidentialityLevelResult.type === dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
    ) {
      yield call(handleError, requestId, responseChannel, channelUrl, type, confidentialityLevelResult.data);
      return;
    }
  }
  
  const {
    ins,
          addAccessAuthorization,
          useBdgAccess,
          bdgAccessReason
  } = params;
  
  const isAuthorized = yield call(isDmpAuthorized, ins, requestId, responseChannel, channelUrl, type, addAccessAuthorization, true);
  if (!isAuthorized) {
    if (addAccessAuthorization) {
      const ok = yield call(handleAddAuthorization, ins, psId, airOnly, authenticationType, esId, requestId, responseChannel, channelUrl, type);
      if (!ok) {
        yield call(handleSetConfidentialityLevel, {
          ins: ins,
          secretConnection
        });
        return;
      }
    } else if (useBdgAccess && bdgAccessReason) {
      yield call(handleSetDmpAccessMode, { accessMode: accessModes.BrisDeGlace, accessModeReason: bdgAccessReason });
      const accessModeResult = yield take([
        dmpCommandSuccessContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION),
        dmpCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)
      ]);
      if (accessModeResult && accessModeResult.type === dmpRemoteCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)) {
        yield call(
          handleError,
          requestId,
          responseChannel,
          channelUrl,
          type,
          accessModeResult.data
        );
        yield call(updateToast, requestId, toast.TYPE.ERROR);
        yield call(handleSetConfidentialityLevel, {
          ins                 : "all",
          confidentialityLevel: Number(secretConnection)
        });
        return;
      }
    } else {
      yield call(handleSetConfidentialityLevel, {
        ins                 : "all",
        confidentialityLevel: Number(secretConnection)
      });
      return;
    }
  }
  if (responseChannel !== remoteResponseChannels.CONNECTOR) {
    yield call(
      sendResponse,
      {
        "@RelatesTo": requestId,
        "@status"   : "urn:ihe:iti:2007:ResponseStatusType:PartialSuccess"
      },
      responseChannel,
      channelUrl,
      type
    );
  }
  
  const findDocumentsResult = yield call(sendActionAndWaitResult, {
    func      : findDocuments(
      params.ins,
      params,
      apiSections.REMOTE_FIND_DOCUMENTS_SECTION
    ),
    section   : apiSections.REMOTE_FIND_DOCUMENTS_SECTION,
    subSection: params.ins
  });
  
  if (findDocumentsResult.type === dmpCommandFailureContextualizedType(apiSections.REMOTE_FIND_DOCUMENTS_SECTION)) {
    yield call(handleError, requestId, responseChannel, channelUrl, type, findDocumentsResult.data);
    
  } else {
    
    yield call(
      sendResponse,
      {
        "@RelatesTo": requestId,
        "@status"   : "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success",
        documents   : rename(findDocumentsResult.data.Documents, key => key.replace(/^s_|^i_/, "")).map(document => ({
          "documentFormat"            : document.document_Format || document.documentFormat,
          "documentStatus"            : document.document_Status || document.documentStatus,
          "documentVisibility"        : document.document_Visibility || document.documentVisibility,
          "creationDate"              : document.creationDate,
          "description"               : document.description,
          "documentFormatCode"        : document.documentFormatCode,
          "documentFormatDescription" : document.documentFormatDescription,
          "healthCareFacilityTypeCode": document.healthCareFacilityTypeCode,
          "nextUUId"                  : document.nextUUId,
          "practiceSettingCode"       : document.practiceSettingCode,
          "previousUUId"              : document.previousUUId,
          "serviceStartDate"          : document.serviceStartDate,
          "serviceStopDate"           : document.serviceStopDate,
          "submissionDate"            : document.submissionDate,
          "submissionSetId"           : document.submissionSetId,
          "title"                     : document.title,
          "typeCode"                  : document.typeCode,
          "uniqueId"                  : document.uniqueId,
          "uuid"                      : document.uuid,
          "EventCodes"                : document.EventCodes.map(code => ({
            "classification": code.eventCodeClassification,
            "code"          : code.eventCodeCode,
            "description"   : code.eventCodeDescription
          })),
          "Authors"                   : document.Authors
        }))
      },
      responseChannel,
      channelUrl,
      type
    );
    yield call(updateToast, requestId, toast.TYPE.SUCCESS);
  }
  
  yield call(handleSetDmpAccessMode, { accessMode: accessModes.NormalAccess, accessModeReason: "" });
  yield call(handleSetConfidentialityLevel, {
    ins                 : "all",
    confidentialityLevel: Number(secretConnection)
  });
}

function * handleGenerateAAT (requestId, requestRest, responseChannel, channelUrl, type, confidentialityLevel) {
  // formatData
  yield put(clearSection(apiSections.SEND_HTTP_REQUEST));
  yield put(saveAATData(requestRest, requestId)); // envoyer les données dans redux
  
  // if (responseChannel !== remoteResponseChannels.CONNECTOR) {
  //   const partialResponse = {
  //     "@RelatesTo": requestId,
  //     "@status"   : "urn:ihe:iti:2007:ResponseStatusType:PartialSuccess"
  //   };
  //
  //   yield call(updateToast, requestId, toast.TYPE.SUCCESS, true);
  //   yield call(sendResponse, partialResponse, responseChannel, channelUrl, type);
  // }
  yield put(push(`/aat/remote`));
  
  let finished = false;
  
  while (!finished) {
    
    const transmittedData = yield take([
      dmpconnectRemoteActionConstants.DMPC_SEND_REMOTE_AAT_RESULT,
      dmpconnectRemoteActionConstants.DMPC_SEND_REMOTE_AAT_PARTIAL_RESULT,
      dmpconnectRemoteActionConstants.DMPC_CANCEL_REMOTE_AAT
    ]);
    
    const {
            type: actionType,
            data: {
              answer,
              answer: {
                errors,
                RelatesTo,
                status
              } = {}
            } = {}
          } = transmittedData;
    
    if (actionType !== dmpconnectRemoteActionConstants.DMPC_SEND_REMOTE_AAT_PARTIAL_RESULT) {
      finished = true;
    }
    
    if (actionType === dmpconnectRemoteActionConstants.DMPC_CANCEL_REMOTE_AAT) {
      const page     = yield select(state => getBackPage(backPagesTypes.DASHBOARD, state));
      const response = generateRemoteFailureResponse(requestId, {
        i_apiErrorType                : errorTypes.RemoteErrors,
        i_apiErrorCode                : "REJECTED_BY_USER",
        s_apiErrorExtendedInformations: "L’utilisateur a rejeté l’action demandée."
      });
      yield call(sendResponse, response, responseChannel, channelUrl, type);
      yield call(updateToast, requestId, toast.TYPE.ERROR);
      yield put(push(page));
      continue;
    }
    
    if (RelatesTo && actionType === dmpconnectRemoteActionConstants.DMPC_SEND_REMOTE_AAT_RESULT) {
      if (errors) {
        // const response = generateRemoteFailureResponse(requestId, answer);
        const response = {
          "@RelatesTo": requestId,
          "@status"   : status,
          errors      : [
            {
              "@code": remoteErrors.INVALID_FORMAT,
              details: [{ ...errors }]
            }
          ]
        };
        yield call(sendResponse, response, responseChannel, channelUrl, type);
        yield call(updateToast, requestId, toast.TYPE.ERROR);
        const page = yield select(state => getBackPage(backPagesTypes.DASHBOARD, state));
        yield put(push(page || `/home`));
      } else {
        const response = {
          "@RelatesTo"      : requestId,
          "@status"         : status,
          employerFormData  : answer.formEmployerData,
          patientReceiptData: answer.formData,
          employerFormPdf   : answer.employerFormPdf,
          patientReceiptPdf : answer.patientReceiptPdf
        };
        yield call(
          sendResponse,
          response,
          responseChannel,
          channelUrl,
          type
        );
        yield call(updateToast, requestId, toast.TYPE.SUCCESS);
      }
    } else {
      const response = {
        "@RelatesTo": requestId,
        "@status"   : status,
        errors      : errors ? [
          {
            "@code": remoteErrors.INVALID_FORMAT,
            details: [{ ...errors }]
          }
        ] : undefined
      };
      yield call(
        sendResponse,
        response,
        responseChannel,
        channelUrl,
        type
      );
      yield call(updateToast, requestId, toast.TYPE.SUCCESS);
    }
  }
}

function * receiveRemoteRequest ({ data, source }) {
  const isLoggedIn        = yield select(isUserLoggedInAccessor);
  const showNotifications = yield select(getShowNotifications);
  const mssClientMode     = yield select(getMssClientMode);
  const {
          message: {
            RemoteCommands                 = [],
            s_apiErrorExtendedInformations = "",
            s_status                       = "",
            i_apiErrorType                 = 0,
            i_apiErrorCode                 = 0
          }
        }                 = data;
  
  if (s_status.toLowerCase() === "error") {
    if (s_apiErrorExtendedInformations === "Unknown command: 'hl_startRemoteControlInMonitoring'") {
      yield put(stopRemoteControl());
      yield put(setGlobalConfiguration("forceDesactivateRemoteControl", true));
    } else if (!(i_apiErrorType === errorTypes.SoftwareErrors && i_apiErrorCode === softwareErrors.WEBSOCKET_TIMEOUT)) {
      const details = createErrorDetails("Erreur détaillée", { detailsType: "error", ...data.message });
      
      const modalError = createModalError({ ...data.message, i_apiErrorType: errorTypes.RemoteErrors }, [details]);
      yield put(setModalError(modalError));
    }
    // toast.error('Mode pilotable désactivé');
  } else {
    yield put(setGlobalConfiguration("forceDesactivateRemoteControl", false));
    
    // did we receive a request
    for (let i = 0; i < RemoteCommands.length; i += 1) {
      const { request, request: { type = remoteFormats.XML } = {} } = RemoteCommands[i];
      
      if (!request) {
        const details = createErrorDetails("received", RemoteCommands[i]);
        
        const modalError = createModalError({
          i_apiErrorCode                : remoteErrors.INVALID_FORMAT,
          i_apiErrorType                : errorTypes.RemoteErrors,
          s_apiErrorDescription         : `La commande n'a pu être lue, veuillez vérifier le contenu.`,
          s_apiErrorExtendedInformations: `La syntaxe ou certaines valeurs de la requête peuvent bloquer sa lecture. Par exemple, une chaine base64 coupée à 80 caractères.`
        }, [details]);
        yield put(setModalError(modalError));
        return;
      }
      
      let requestId;
      let action;
      let confidentialityLevel;
      let channel;
      let channelUrl;
      let requestRest;

      if (type === remoteFormats.JSON) {
        ({
          id: requestId,
          action,
          confidentialityLevel = -1,
          responseChannel: channel,
          responseChannelUrl: channelUrl = undefined,
          ...requestRest
        } = request);
      } else {
        ({
          "@id": requestId,
          "@action": action,
          "@confidentialityLevel": confidentialityLevel = -1,
          "@responseChannel": channel,
          "@responseChannelUrl": channelUrl = undefined,
          ...requestRest
        } = request);
      }

      let secretConnexion = -1;
      if ([true, "true", "1", 1].includes(confidentialityLevel)) {
        secretConnexion = 1;
      } else if ([false, "false", "0", 0].includes(confidentialityLevel)) {
        secretConnexion = 0;
      }
      
      const responseChannel = source === remoteSources.CONNECTOR ? remoteResponseChannels.CONNECTOR : channel;
      
      if (showNotifications === true) {
        toast(
          `requête pilotage reçue : ${action} (${requestId})`,
          {
            toastId  : requestId,
            autoClose: false
          }
        );
      }
      
      if (
        ![
          remoteActions.getMssNbUnreadMessages,
          remoteActions.sendMssMessage,
          remoteActions.getStatus,
          remoteActions.getEfficienceVersion,
          remoteActions.getMssHpInfos,
          remoteActions.logout,
          remoteActions.sendCpxPinCode,
          remoteActions.setPscAccessToken,
          remoteActions.setMssPatientInfos
        ].includes(action)
        && mssClientMode === true
      ) {
        yield call(handleRefusedActionError, requestId, responseChannel, channelUrl, type);
      } else {
        try {
          const categories         = yield select(getInteropCodesFromState, "categories");
          // const healthcareSettings = yield select(getInteropCodesFromState, 'healthcareSettings');
          const typeActivite       = yield select(getNosCodesFromState, "tre_r209-typeactivite");
          const secteurActivite    = yield select(getNosCodesFromState, "tre_r02-secteuractivite");
          const healthcareSettings = [...typeActivite, ...secteurActivite].map(hs => ({ code: hs.s_code }));
          
          const professions = yield select(getInteropCodesFromState, "professions");
          const specialties = yield select(getInteropCodesFromState, "physicianSpecialities");
          const mssApiType  = yield select(getMssApiType);
          
          validateCommand(request, categories, healthcareSettings, professions, specialties, mssApiType, type);
          
          if (!isLoggedIn && ![
            remoteActions.getEfficienceVersion,
            remoteActions.getStatus,
            remoteActions.logout,
            remoteActions.sendCpxPinCode,
            remoteActions.setPscAccessToken
          ].includes(action)) {
            yield call(handleLoggedInError, requestId, responseChannel, channelUrl, type);
          } else {
            switch (action) {
              case remoteActions.getCertifiedIdentity:
                yield call(
                  handleGetCertifiedIdentity,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.getCurrentDmp:
                yield call(handleGetCurrentDMPRemoteRequest, requestId, responseChannel, channelUrl, type);
                break;
              case remoteActions.findDmp:
                yield call(handleFindDMPRemoteRequest, requestId, requestRest, responseChannel, channelUrl, type);
                break;
              case remoteActions.testDmpExistence:
                yield call(
                  handleTestDmpExistenceRemoteRequest,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.openDmp:
              case "openOrCreateDmp":
                yield call(
                  handleOpenDmp,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.submitDocument:
                yield call(
                  handleSubmitDocument,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.sendSubmissionSet:
                yield call(
                  handleSendSubmissionSet,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.deleteDocument:
                yield call(
                  handleDeleteDocument,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.findDocuments:
                yield call(handleFindDocuments,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.getDocumentsStatus:
                yield call(handleGetDocumentsStatus,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.openDocument:
                yield call(handleOpenDocument,
                  requestId,
                  secretConnexion,
                  requestRest,
                  responseChannel,
                  channelUrl,
                  type
                );
                break;
              case remoteActions.closeDmpSession:
                yield call(handleCloseDmpSession, requestId, responseChannel, channelUrl, type);
                break;
              case remoteActions.getEfficienceVersion:
                yield call(handleGetEfficienceVersion, requestId, responseChannel, channelUrl, type);
                break;
              case remoteActions.getStatus:
                yield call(handleGetStatus, requestId, responseChannel, channelUrl, type);
                break;
              case remoteActions.sendMssMessage:
                yield call(handleSendMssMessage, requestId, requestRest, responseChannel, channelUrl, type);
                break;
              case remoteActions.getMssNbUnreadMessages:
                yield call(handleGetMssNbUnreadMessages, requestId, requestRest, responseChannel, channelUrl, type);
                break;
              case remoteActions.getMssHpInfos:
                yield call(handleGetMssHpInfos, requestId, requestRest, responseChannel, channelUrl, type);
                break;
              case remoteActions.logout:
                yield call(handleLogout, requestId, responseChannel, channelUrl, type);
                break;
              case remoteActions.sendCpxPinCode:
                yield call(handleCpxPinCode, requestId, requestRest, responseChannel, channelUrl, type);
                break;
              case remoteActions.setPscAccessToken:
                yield call(handlePscAccessToken, requestId, requestRest, responseChannel, channelUrl, type, isLoggedIn);
                break;
              case remoteActions.generateAat:
                yield call(handleGenerateAAT, requestId, requestRest, responseChannel, channelUrl, type);
                break;
              case remoteActions.setMssPatientInfos:
                yield call(handleSetMssPatientInfos, requestId, requestRest, responseChannel, channelUrl, type);
                break;
              default:
                yield call(handleUnknownActionError, requestId, responseChannel, channelUrl, type);
            }
          }
        } catch (e) {
          console.log(e);
          let response;
          if (e instanceof ValidationError) {
            response = generateRemoteFailureResponse(
              requestId,
              {
                i_apiErrorType                : errorTypes.RemoteErrors,
                i_apiErrorCode                : "INVALID_FORMAT",
                s_apiErrorExtendedInformations: `${type} invalide`
              },
              e.inner.map(error => ({
                field: error.path ? error.path.replace(".value", "") : undefined,
                value: error.path ? error.value : undefined,
                error: error.message
              }))
            );
          } else {
            response = generateRemoteFailureResponse(
              requestId,
              {
                i_apiErrorType                : errorTypes.RemoteErrors,
                i_apiErrorCode                : "INVALID_FORMAT",
                s_apiErrorExtendedInformations: e.message
              }
            );
          }
          
          yield call(sendResponse, response, responseChannel, channelUrl, type);
          yield call(updateToast, requestId, toast.TYPE.ERROR);
        }
      }
    }
  }
}

export const handleReceivedRemoteRequest = function * () {
  const requestChannel = yield actionChannel(dmpconnectRemoteActionConstants.DMPC_REMOTE_MONITORING_RECEIVED_REQUEST);
  while (true) {
    const action = yield take(requestChannel);
    yield call(receiveRemoteRequest, action);
  }
};

/**
 * Manage monitoring update
 * @param socketChannel
 * @param updateType
 * @returns {IterableIterator<CallEffect|TakeEffect|PutEffect<{data, context, type, command}>>}
 */
function * receivingRemoteRequest (socketChannel, updateType) {
  while (true) {
    const payload                                   = yield take(socketChannel);
    const { message: { RemoteCommands = [] } = {} } = payload;
    if (RemoteCommands.length > 0) {
      console.log("incomingMessage_connector", payload);
    }
    yield put({
      type  : updateType,
      data  : payload,
      source: remoteSources.CONNECTOR
    });
  }
}

export const handleRemoteMonitoring = function * () {
  const monitoringAction = {
    startAction : dmpconnectRemoteActionConstants.DMPC_REMOTE_MONITORING_START,
    stopAction  : dmpconnectRemoteActionConstants.DMPC_REMOTE_MONITORING_STOP,
    updateAction: dmpconnectRemoteActionConstants.DMPC_REMOTE_MONITORING_RECEIVED_REQUEST
  };
  
  while (true) {
    const { command }         = yield take(monitoringAction.startAction);
    const remoteControlActive = yield select(isRemoteControlActive);
    
    if (remoteControlActive) {
      const socketChannel = yield call(websocketChannel, command, null, true);
      
      const { cancel } = yield race({
        task  : call(
          receivingRemoteRequest,
          socketChannel,
          monitoringAction.updateAction
        ),
        cancel: take(monitoringAction.stopAction)
      });
      if (cancel) {
        socketChannel.close();
      }
    }
  }
};
